// AUTO-GENERATED by scripts/generate-pokemon-forms.ts - DO NOT EDIT BY HAND.
// Refresh via: npm run generate:forms   (or the monthly refresh workflow)
// Source: https://graphql.pokeapi.co/v1beta2   (build-time only)

import type { FormGroup } from "../types/forms";

export const POKEMON_FORM_GROUPS: readonly FormGroup[] = [
  {
    "speciesId": 1,
    "baseDexId": 1,
    "speciesName": "bulbasaur",
    "forms": [
      {
        "formId": "bulbasaur",
        "name": "bulbasaur",
        "displayName": "Bulbasaur",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/1.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/1.png",
        "isDefault": true
      },
      {
        "formId": "bulbasaur-fall-2019",
        "name": "bulbasaur-fall-2019",
        "displayName": "Fall 2019",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm1.fFALL_2019.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm1.fFALL_2019.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "bulbasaur-jan-2020",
        "name": "bulbasaur-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm1.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm1.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "bulbasaur-spring-2020",
        "name": "bulbasaur-spring-2020",
        "displayName": "Spring 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm1.cSPRING_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm1.cSPRING_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 2,
    "baseDexId": 2,
    "speciesName": "ivysaur",
    "forms": [
      {
        "formId": "ivysaur",
        "name": "ivysaur",
        "displayName": "Ivysaur",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/2.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/2.png",
        "isDefault": true
      },
      {
        "formId": "ivysaur-jan-2020",
        "name": "ivysaur-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm2.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm2.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "ivysaur-spring-2020",
        "name": "ivysaur-spring-2020",
        "displayName": "Spring 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm2.cSPRING_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm2.cSPRING_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 3,
    "baseDexId": 3,
    "speciesName": "venusaur",
    "forms": [
      {
        "formId": "venusaur",
        "name": "venusaur",
        "displayName": "Venusaur",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/3.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/3.png",
        "isDefault": true
      },
      {
        "formId": "venusaur-jan-2020",
        "name": "venusaur-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm3.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm3.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "venusaur-spring-2020",
        "name": "venusaur-spring-2020",
        "displayName": "Spring 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm3.cSPRING_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm3.cSPRING_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 4,
    "baseDexId": 4,
    "speciesName": "charmander",
    "forms": [
      {
        "formId": "charmander",
        "name": "charmander",
        "displayName": "Charmander",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/4.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/4.png",
        "isDefault": true
      },
      {
        "formId": "charmander-goggles-2026",
        "name": "charmander-goggles-2026",
        "displayName": "Friede's Goggles",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm4.fGOGGLES_2026.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm4.fGOGGLES_2026.s.icon.png",
        "isDefault": false,
        "releaseAtLocal": "2026-09-16T10:00",
        "kind": "costume"
      },
      {
        "formId": "charmander-fall-2019",
        "name": "charmander-fall-2019",
        "displayName": "Fall 2019",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm4.fFALL_2019.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm4.fFALL_2019.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "charmander-jan-2020",
        "name": "charmander-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm4.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm4.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "charmander-spring-2020",
        "name": "charmander-spring-2020",
        "displayName": "Spring 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm4.cSPRING_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm4.cSPRING_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 5,
    "baseDexId": 5,
    "speciesName": "charmeleon",
    "forms": [
      {
        "formId": "charmeleon",
        "name": "charmeleon",
        "displayName": "Charmeleon",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/5.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/5.png",
        "isDefault": true
      },
      {
        "formId": "charmeleon-goggles-2026",
        "name": "charmeleon-goggles-2026",
        "displayName": "Friede's Goggles",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm5.fGOGGLES_2026.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm5.fGOGGLES_2026.s.icon.png",
        "isDefault": false,
        "releaseAtLocal": "2026-09-16T10:00",
        "kind": "costume"
      },
      {
        "formId": "charmeleon-jan-2020",
        "name": "charmeleon-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm5.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm5.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "charmeleon-spring-2020",
        "name": "charmeleon-spring-2020",
        "displayName": "Spring 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm5.cSPRING_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm5.cSPRING_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 6,
    "baseDexId": 6,
    "speciesName": "charizard",
    "forms": [
      {
        "formId": "charizard",
        "name": "charizard",
        "displayName": "Charizard",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/6.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/6.png",
        "isDefault": true
      },
      {
        "formId": "charizard-goggles-2026",
        "name": "charizard-goggles-2026",
        "displayName": "Friede's Goggles",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm6.fGOGGLES_2026.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm6.fGOGGLES_2026.s.icon.png",
        "isDefault": false,
        "releaseAtLocal": "2026-09-16T10:00",
        "kind": "costume"
      },
      {
        "formId": "charizard-jan-2020",
        "name": "charizard-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm6.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm6.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "charizard-spring-2020",
        "name": "charizard-spring-2020",
        "displayName": "Spring 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm6.cSPRING_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm6.cSPRING_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 7,
    "baseDexId": 7,
    "speciesName": "squirtle",
    "forms": [
      {
        "formId": "squirtle",
        "name": "squirtle",
        "displayName": "Squirtle",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/7.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/7.png",
        "isDefault": true
      },
      {
        "formId": "squirtle-fall-2019",
        "name": "squirtle-fall-2019",
        "displayName": "Fall 2019",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm7.fFALL_2019.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm7.fFALL_2019.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "squirtle-jan-2020",
        "name": "squirtle-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm7.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm7.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "squirtle-spring-2020",
        "name": "squirtle-spring-2020",
        "displayName": "Spring 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm7.cSPRING_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm7.cSPRING_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "squirtle-summer-2018",
        "name": "squirtle-summer-2018",
        "displayName": "Summer 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm7.cSUMMER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm7.cSUMMER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 8,
    "baseDexId": 8,
    "speciesName": "wartortle",
    "forms": [
      {
        "formId": "wartortle",
        "name": "wartortle",
        "displayName": "Wartortle",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/8.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/8.png",
        "isDefault": true
      },
      {
        "formId": "wartortle-jan-2020",
        "name": "wartortle-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm8.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm8.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "wartortle-spring-2020",
        "name": "wartortle-spring-2020",
        "displayName": "Spring 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm8.cSPRING_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm8.cSPRING_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "wartortle-summer-2018",
        "name": "wartortle-summer-2018",
        "displayName": "Summer 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm8.cSUMMER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm8.cSUMMER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 9,
    "baseDexId": 9,
    "speciesName": "blastoise",
    "forms": [
      {
        "formId": "blastoise",
        "name": "blastoise",
        "displayName": "Blastoise",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/9.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/9.png",
        "isDefault": true
      },
      {
        "formId": "blastoise-jan-2020",
        "name": "blastoise-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm9.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm9.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "blastoise-spring-2020",
        "name": "blastoise-spring-2020",
        "displayName": "Spring 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm9.cSPRING_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm9.cSPRING_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "blastoise-summer-2018",
        "name": "blastoise-summer-2018",
        "displayName": "Summer 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm9.cSUMMER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm9.cSUMMER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 10,
    "baseDexId": 10,
    "speciesName": "caterpie",
    "forms": [
      {
        "formId": "caterpie",
        "name": "caterpie",
        "displayName": "Caterpie",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10.png",
        "isDefault": true
      },
      {
        "formId": "caterpie-gofest-2026",
        "name": "caterpie-gofest-2026",
        "displayName": "Poké Ball Hat",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm10.fGOFEST_2026.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm10.fGOFEST_2026.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 12,
    "baseDexId": 12,
    "speciesName": "butterfree",
    "forms": [
      {
        "formId": "butterfree",
        "name": "butterfree",
        "displayName": "Butterfree",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/12.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/12.png",
        "isDefault": true
      },
      {
        "formId": "butterfree-fashion-2021",
        "name": "butterfree-fashion-2021",
        "displayName": "Fashion 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm12.cFASHION_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm12.cFASHION_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 19,
    "baseDexId": 19,
    "speciesName": "rattata",
    "forms": [
      {
        "formId": "rattata",
        "name": "rattata",
        "displayName": "Rattata",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/19.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/19.png",
        "isDefault": true
      },
      {
        "formId": "rattata-alola",
        "name": "rattata-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10091.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10091.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 20,
    "baseDexId": 20,
    "speciesName": "raticate",
    "forms": [
      {
        "formId": "raticate",
        "name": "raticate",
        "displayName": "Raticate",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/20.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/20.png",
        "isDefault": true
      },
      {
        "formId": "raticate-alola",
        "name": "raticate-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10092.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10092.png",
        "isDefault": true
      },
      {
        "formId": "raticate-jan-2020",
        "name": "raticate-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm20.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm20.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 25,
    "baseDexId": 25,
    "speciesName": "pikachu",
    "forms": [
      {
        "formId": "pikachu",
        "name": "pikachu",
        "displayName": "Pikachu",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/25.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/25.png",
        "isDefault": true
      },
      {
        "formId": "pikachu-rock-star",
        "name": "pikachu-rock-star",
        "displayName": "Rock Star",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10080.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10080.png",
        "isDefault": true,
        "kind": "costume"
      },
      {
        "formId": "pikachu-pop-star",
        "name": "pikachu-pop-star",
        "displayName": "Pop Star",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10082.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10082.png",
        "isDefault": true,
        "kind": "costume"
      },
      {
        "formId": "pikachu-original-cap",
        "name": "pikachu-original-cap",
        "displayName": "Original Cap",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10094.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10094.png",
        "isDefault": true,
        "kind": "costume"
      },
      {
        "formId": "pikachu-hoenn-cap",
        "name": "pikachu-hoenn-cap",
        "displayName": "Hoenn Cap",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10095.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10095.png",
        "isDefault": true,
        "kind": "costume"
      },
      {
        "formId": "pikachu-sinnoh-cap",
        "name": "pikachu-sinnoh-cap",
        "displayName": "Sinnoh Cap",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10096.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10096.png",
        "isDefault": true,
        "kind": "costume"
      },
      {
        "formId": "pikachu-unova-cap",
        "name": "pikachu-unova-cap",
        "displayName": "Unova Cap",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10097.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10097.png",
        "isDefault": true,
        "kind": "costume"
      },
      {
        "formId": "pikachu-kalos-cap",
        "name": "pikachu-kalos-cap",
        "displayName": "Kalos Cap",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10098.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10098.png",
        "isDefault": true,
        "kind": "costume"
      },
      {
        "formId": "pikachu-alola-cap",
        "name": "pikachu-alola-cap",
        "displayName": "Alola Cap",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10099.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10099.png",
        "isDefault": true,
        "kind": "costume"
      },
      {
        "formId": "pikachu-partner-cap",
        "name": "pikachu-partner-cap",
        "displayName": "Partner Cap",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10148.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10148.png",
        "isDefault": true,
        "kind": "costume"
      },
      {
        "formId": "pikachu-world-cap",
        "name": "pikachu-world-cap",
        "displayName": "World Cap",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10160.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10160.png",
        "isDefault": true,
        "kind": "costume"
      },
      {
        "formId": "pikachu-adventure-hat-2020",
        "name": "pikachu-adventure-hat-2020",
        "displayName": "Adventure Hat 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fADVENTURE_HAT_2020.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fADVENTURE_HAT_2020.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-bb-2026",
        "name": "pikachu-bb-2026",
        "displayName": "BB 2026",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fBB_2026.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fBB_2026.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-copy-2019",
        "name": "pikachu-copy-2019",
        "displayName": "Copy 2019",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fCOPY_2019.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fCOPY_2019.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-costume-2020",
        "name": "pikachu-costume-2020",
        "displayName": "Costume 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fCOSTUME_2020.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fCOSTUME_2020.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-diwali-2024",
        "name": "pikachu-diwali-2024",
        "displayName": "Diwali 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fDIWALI_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fDIWALI_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-doctor",
        "name": "pikachu-doctor",
        "displayName": "Doctor",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fDOCTOR.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fDOCTOR.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-fall-2019",
        "name": "pikachu-fall-2019",
        "displayName": "Fall 2019",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFALL_2019.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFALL_2019.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-flying-01",
        "name": "pikachu-flying-01",
        "displayName": "Flying 01",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFLYING_01.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFLYING_01.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-flying-02",
        "name": "pikachu-flying-02",
        "displayName": "Flying 02",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFLYING_02.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFLYING_02.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-flying-03",
        "name": "pikachu-flying-03",
        "displayName": "Flying 03",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFLYING_03.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFLYING_03.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-flying-04",
        "name": "pikachu-flying-04",
        "displayName": "Flying 04",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFLYING_04.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFLYING_04.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-flying-5th-anniv",
        "name": "pikachu-flying-5th-anniv",
        "displayName": "Flying 5th Anniversary",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFLYING_5TH_ANNIV.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFLYING_5TH_ANNIV.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-flying-okinawa",
        "name": "pikachu-flying-okinawa",
        "displayName": "Flying Okinawa",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFLYING_OKINAWA.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFLYING_OKINAWA.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gofest-2022",
        "name": "pikachu-gofest-2022",
        "displayName": "GO Fest 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gofest-2024-mtiara",
        "name": "pikachu-gofest-2024-mtiara",
        "displayName": "GO Fest 2024 M Tiara",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2024_MTIARA.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2024_MTIARA.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gofest-2024-stiara",
        "name": "pikachu-gofest-2024-stiara",
        "displayName": "GO Fest 2024 S Tiara",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2024_STIARA.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2024_STIARA.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gofest-2025-goggles-blue",
        "name": "pikachu-gofest-2025-goggles-blue",
        "displayName": "GO Fest 2025 Goggles Blue",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2025_GOGGLES_BLUE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2025_GOGGLES_BLUE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gofest-2025-goggles-red",
        "name": "pikachu-gofest-2025-goggles-red",
        "displayName": "GO Fest 2025 Goggles Red",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2025_GOGGLES_RED.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2025_GOGGLES_RED.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gofest-2025-goggles-yellow",
        "name": "pikachu-gofest-2025-goggles-yellow",
        "displayName": "GO Fest 2025 Goggles Yellow",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2025_GOGGLES_YELLOW.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2025_GOGGLES_YELLOW.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gofest-2025-monocle-blue",
        "name": "pikachu-gofest-2025-monocle-blue",
        "displayName": "GO Fest 2025 Monocle Blue",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2025_MONOCLE_BLUE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2025_MONOCLE_BLUE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gofest-2025-monocle-red",
        "name": "pikachu-gofest-2025-monocle-red",
        "displayName": "GO Fest 2025 Monocle Red",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2025_MONOCLE_RED.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2025_MONOCLE_RED.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gofest-2025-monocle-yellow",
        "name": "pikachu-gofest-2025-monocle-yellow",
        "displayName": "GO Fest 2025 Monocle Yellow",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2025_MONOCLE_YELLOW.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2025_MONOCLE_YELLOW.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2024-a",
        "name": "pikachu-gotour-2024-a",
        "displayName": "GO Tour 2024 A",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2024_A.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2024_A.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2024-a-02",
        "name": "pikachu-gotour-2024-a-02",
        "displayName": "GO Tour 2024 A 02",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2024_A_02.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2024_A_02.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2024-b",
        "name": "pikachu-gotour-2024-b",
        "displayName": "GO Tour 2024 B",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2024_B.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2024_B.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2024-b-02",
        "name": "pikachu-gotour-2024-b-02",
        "displayName": "GO Tour 2024 B 02",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2024_B_02.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2024_B_02.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2025-a",
        "name": "pikachu-gotour-2025-a",
        "displayName": "GO Tour 2025 A",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2025_A.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2025_A.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2025-a-02",
        "name": "pikachu-gotour-2025-a-02",
        "displayName": "GO Tour 2025 A 02",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2025_A_02.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2025_A_02.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2025-b",
        "name": "pikachu-gotour-2025-b",
        "displayName": "GO Tour 2025 B",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2025_B.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2025_B.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2025-b-02",
        "name": "pikachu-gotour-2025-b-02",
        "displayName": "GO Tour 2025 B 02",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2025_B_02.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2025_B_02.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2026-a",
        "name": "pikachu-gotour-2026-a",
        "displayName": "GO Tour 2026 A",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2026_A.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2026_A.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2026-a-02",
        "name": "pikachu-gotour-2026-a-02",
        "displayName": "GO Tour 2026 A 02",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2026_A_02.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2026_A_02.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2026-b",
        "name": "pikachu-gotour-2026-b",
        "displayName": "GO Tour 2026 B",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2026_B.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2026_B.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2026-b-02",
        "name": "pikachu-gotour-2026-b-02",
        "displayName": "GO Tour 2026 B 02",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2026_B_02.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2026_B_02.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2026-c",
        "name": "pikachu-gotour-2026-c",
        "displayName": "GO Tour 2026 C",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2026_C.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2026_C.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2026-c-02",
        "name": "pikachu-gotour-2026-c-02",
        "displayName": "GO Tour 2026 C 02",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2026_C_02.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOTOUR_2026_C_02.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-horizons",
        "name": "pikachu-horizons",
        "displayName": "Horizons",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fHORIZONS.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fHORIZONS.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-jeju",
        "name": "pikachu-jeju",
        "displayName": "Jeju",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fJEJU.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fJEJU.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-kariyushi",
        "name": "pikachu-kariyushi",
        "displayName": "Kariyushi",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fKARIYUSHI.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fKARIYUSHI.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-kurta",
        "name": "pikachu-kurta",
        "displayName": "Kurta",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fKURTA.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fKURTA.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-summer-2023-a",
        "name": "pikachu-summer-2023-a",
        "displayName": "Summer 2023 A",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fSUMMER_2023_A.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fSUMMER_2023_A.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-summer-2023-b",
        "name": "pikachu-summer-2023-b",
        "displayName": "Summer 2023 B",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fSUMMER_2023_B.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fSUMMER_2023_B.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-summer-2023-c",
        "name": "pikachu-summer-2023-c",
        "displayName": "Summer 2023 C",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fSUMMER_2023_C.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fSUMMER_2023_C.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-summer-2023-d",
        "name": "pikachu-summer-2023-d",
        "displayName": "Summer 2023 D",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fSUMMER_2023_D.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fSUMMER_2023_D.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-summer-2023-e",
        "name": "pikachu-summer-2023-e",
        "displayName": "Summer 2023 E",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fSUMMER_2023_E.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fSUMMER_2023_E.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-tshirt-01",
        "name": "pikachu-tshirt-01",
        "displayName": "Green Shirt (Berry)",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fTSHIRT_01.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fTSHIRT_01.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-tshirt-02",
        "name": "pikachu-tshirt-02",
        "displayName": "Purple Shirt (Flower)",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fTSHIRT_02.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fTSHIRT_02.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-tshirt-03",
        "name": "pikachu-tshirt-03",
        "displayName": "Batik Shirt",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fTSHIRT_03.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fTSHIRT_03.s.icon.png",
        "isDefault": false,
        "releaseAtLocal": "2026-10-02T10:00",
        "kind": "costume"
      },
      {
        "formId": "pikachu-vs-2019",
        "name": "pikachu-vs-2019",
        "displayName": "Libre",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fVS_2019.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fVS_2019.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-wcs-2022",
        "name": "pikachu-wcs-2022",
        "displayName": "WCS 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fWCS_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fWCS_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-wcs-2023",
        "name": "pikachu-wcs-2023",
        "displayName": "WCS 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fWCS_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fWCS_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-wcs-2024",
        "name": "pikachu-wcs-2024",
        "displayName": "WCS 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fWCS_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fWCS_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-wcs-2025",
        "name": "pikachu-wcs-2025",
        "displayName": "WCS 2025",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fWCS_2025.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fWCS_2025.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-pxp-2026",
        "name": "pikachu-pxp-2026",
        "displayName": "PokémonXP 2026",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fPXP_2026.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fPXP_2026.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-visor-2026",
        "name": "pikachu-visor-2026",
        "displayName": "Marathon Visor",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fVISOR_2026.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fVISOR_2026.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-fossil-2026",
        "name": "pikachu-fossil-2026",
        "displayName": "Excavator",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFOSSIL_2026.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fFOSSIL_2026.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-anniversary-2026",
        "name": "pikachu-anniversary-2026",
        "displayName": "Anniversary 2026",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fANNIVERSARY_2026.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fANNIVERSARY_2026.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gofest-2026-cap-blue",
        "name": "pikachu-gofest-2026-cap-blue",
        "displayName": "GO Fest 2026 Mystic Cap",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2026_CAP_BLUE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2026_CAP_BLUE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gofest-2026-cap-red",
        "name": "pikachu-gofest-2026-cap-red",
        "displayName": "GO Fest 2026 Valor Cap",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2026_CAP_RED.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2026_CAP_RED.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gofest-2026-cap-yellow",
        "name": "pikachu-gofest-2026-cap-yellow",
        "displayName": "GO Fest 2026 Instinct Cap",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2026_CAP_YELLOW.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGOFEST_2026_CAP_YELLOW.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-anniversary-2026-malaysia-01",
        "name": "pikachu-anniversary-2026-malaysia-01",
        "displayName": "PokéXciting Malaysia",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fANNIVERSARY_2026_MALAYSIA_01.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fANNIVERSARY_2026_MALAYSIA_01.s.icon.png",
        "isDefault": false,
        "releaseAtLocal": "2026-09-01T10:00",
        "kind": "costume"
      },
      {
        "formId": "pikachu-anniversary-2026-taiwan-01",
        "name": "pikachu-anniversary-2026-taiwan-01",
        "displayName": "PokéXciting Taiwan",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fANNIVERSARY_2026_TAIWAN_01.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fANNIVERSARY_2026_TAIWAN_01.s.icon.png",
        "isDefault": false,
        "releaseAtLocal": "2026-10-01T10:00",
        "kind": "costume"
      },
      {
        "formId": "pikachu-anniversary-2026-singapore-01",
        "name": "pikachu-anniversary-2026-singapore-01",
        "displayName": "PokéXciting Singapore",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fANNIVERSARY_2026_SINGAPORE_01.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fANNIVERSARY_2026_SINGAPORE_01.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-anniversary-2026-philippine-01",
        "name": "pikachu-anniversary-2026-philippine-01",
        "displayName": "PokéXciting Philippines",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fANNIVERSARY_2026_PHILIPPINE_01.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fANNIVERSARY_2026_PHILIPPINE_01.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-wcs-2026",
        "name": "pikachu-wcs-2026",
        "displayName": "WCS 2026",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fWCS_2026.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fWCS_2026.s.icon.png",
        "isDefault": false,
        "releaseAtLocal": "2026-08-28T10:00",
        "kind": "costume"
      },
      {
        "formId": "pikachu-astronaut-2026",
        "name": "pikachu-astronaut-2026",
        "displayName": "Astronaut",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGLASS_HELMET_2026.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fGLASS_HELMET_2026.s.icon.png",
        "isDefault": false,
        "shinyReleaseAtLocal": "2026-10-04T00:00",
        "kind": "costume"
      },
      {
        "formId": "pikachu-hanbok-2026",
        "name": "pikachu-hanbok-2026",
        "displayName": "Orange Hanbok",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fK_2026_A_01.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fK_2026_A_01.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-halloween-2026",
        "name": "pikachu-halloween-2026",
        "displayName": "Halloween 2026",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fHALLOWEEN_2026.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fHALLOWEEN_2026.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-winter-2020",
        "name": "pikachu-winter-2020",
        "displayName": "Winter 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fWINTER_2020.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.fWINTER_2020.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-anniversary",
        "name": "pikachu-anniversary",
        "displayName": "Anniversary",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cANNIVERSARY.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cANNIVERSARY.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-anniversary-2022",
        "name": "pikachu-anniversary-2022",
        "displayName": "Anniversary 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cANNIVERSARY_2022_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cANNIVERSARY_2022_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-april-2020",
        "name": "pikachu-april-2020",
        "displayName": "April 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cAPRIL_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cAPRIL_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-costume-1",
        "name": "pikachu-costume-1",
        "displayName": "Costume 1",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cCOSTUME_1.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cCOSTUME_1.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-costume-2",
        "name": "pikachu-costume-2",
        "displayName": "Costume 2",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cCOSTUME_2.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cCOSTUME_2.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-fall-2018",
        "name": "pikachu-fall-2018",
        "displayName": "Fall 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cFALL_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cFALL_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-fall-2023",
        "name": "pikachu-fall-2023",
        "displayName": "Fall 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cFALL_2023_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cFALL_2023_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-feb-2019",
        "name": "pikachu-feb-2019",
        "displayName": "Feb 2019",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cFEB_2019.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cFEB_2019.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gofest-2021",
        "name": "pikachu-gofest-2021",
        "displayName": "Gofest 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cGOFEST_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cGOFEST_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2023-bandana",
        "name": "pikachu-gotour-2023-bandana",
        "displayName": "Gotour 2023 Bandana",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cGOTOUR_2023_BANDANA.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cGOTOUR_2023_BANDANA.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-gotour-2023-hat",
        "name": "pikachu-gotour-2023-hat",
        "displayName": "Gotour 2023 Hat",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cGOTOUR_2023_HAT.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cGOTOUR_2023_HAT.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-halloween-2017",
        "name": "pikachu-halloween-2017",
        "displayName": "Halloween 2017",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cHALLOWEEN_2017.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cHALLOWEEN_2017.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-halloween-2021",
        "name": "pikachu-halloween-2021",
        "displayName": "Halloween 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cHALLOWEEN_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cHALLOWEEN_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-hoenn-2020",
        "name": "pikachu-hoenn-2020",
        "displayName": "Hoenn 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cHOENN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cHOENN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-holiday-2016",
        "name": "pikachu-holiday-2016",
        "displayName": "Holiday 2016",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cHOLIDAY_2016.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cHOLIDAY_2016.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-holiday-2023",
        "name": "pikachu-holiday-2023",
        "displayName": "Holiday 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cHOLIDAY_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cHOLIDAY_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-indonesia-2025",
        "name": "pikachu-indonesia-2025",
        "displayName": "Indonesia 2025",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cINDONESIA_2025_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cINDONESIA_2025_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-jan-2020",
        "name": "pikachu-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-jan-2023",
        "name": "pikachu-jan-2023",
        "displayName": "Jan 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cJAN_2023_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cJAN_2023_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-johto-2020",
        "name": "pikachu-johto-2020",
        "displayName": "Johto 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cJOHTO_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cJOHTO_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-kanto-2020",
        "name": "pikachu-kanto-2020",
        "displayName": "Kanto 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cKANTO_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cKANTO_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-may-2019",
        "name": "pikachu-may-2019",
        "displayName": "May 2019",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cMAY_2019_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cMAY_2019_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-november-2018",
        "name": "pikachu-november-2018",
        "displayName": "November 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cNOVEMBER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cNOVEMBER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-one-year-anniversary",
        "name": "pikachu-one-year-anniversary",
        "displayName": "One Year Anniversary",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cONE_YEAR_ANNIVERSARY.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cONE_YEAR_ANNIVERSARY.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-pi",
        "name": "pikachu-pi",
        "displayName": "Pi",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cPI.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cPI.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-safari-2020",
        "name": "pikachu-safari-2020",
        "displayName": "Safari 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cSAFARI_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cSAFARI_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-sinnoh-2020",
        "name": "pikachu-sinnoh-2020",
        "displayName": "Sinnoh 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cSINNOH_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cSINNOH_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-spring-2023",
        "name": "pikachu-spring-2023",
        "displayName": "Spring 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cSPRING_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cSPRING_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-summer-2018",
        "name": "pikachu-summer-2018",
        "displayName": "Summer 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cSUMMER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cSUMMER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-tcg-2022",
        "name": "pikachu-tcg-2022",
        "displayName": "Tcg 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cTCG_2022_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cTCG_2022_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pikachu-winter-2018",
        "name": "pikachu-winter-2018",
        "displayName": "Winter 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cWINTER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm25.cWINTER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 26,
    "baseDexId": 26,
    "speciesName": "raichu",
    "forms": [
      {
        "formId": "raichu",
        "name": "raichu",
        "displayName": "Raichu",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/26.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/26.png",
        "isDefault": true
      },
      {
        "formId": "raichu-alola",
        "name": "raichu-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10100.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10100.png",
        "isDefault": true
      },
      {
        "formId": "raichu-anniversary",
        "name": "raichu-anniversary",
        "displayName": "Anniversary",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cANNIVERSARY.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cANNIVERSARY.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "raichu-costume-1",
        "name": "raichu-costume-1",
        "displayName": "Costume 1",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cCOSTUME_1.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cCOSTUME_1.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "raichu-costume-2",
        "name": "raichu-costume-2",
        "displayName": "Costume 2",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cCOSTUME_2.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cCOSTUME_2.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "raichu-fall-2018",
        "name": "raichu-fall-2018",
        "displayName": "Fall 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cFALL_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cFALL_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "raichu-feb-2019",
        "name": "raichu-feb-2019",
        "displayName": "Feb 2019",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cFEB_2019.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cFEB_2019.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "raichu-halloween-2017",
        "name": "raichu-halloween-2017",
        "displayName": "Halloween 2017",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cHALLOWEEN_2017.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cHALLOWEEN_2017.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "raichu-holiday-2016",
        "name": "raichu-holiday-2016",
        "displayName": "Holiday 2016",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cHOLIDAY_2016.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cHOLIDAY_2016.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "raichu-holiday-2023",
        "name": "raichu-holiday-2023",
        "displayName": "Holiday 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cHOLIDAY_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cHOLIDAY_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "raichu-november-2018",
        "name": "raichu-november-2018",
        "displayName": "November 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cNOVEMBER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cNOVEMBER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "raichu-one-year-anniversary",
        "name": "raichu-one-year-anniversary",
        "displayName": "One Year Anniversary",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cONE_YEAR_ANNIVERSARY.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cONE_YEAR_ANNIVERSARY.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "raichu-pi",
        "name": "raichu-pi",
        "displayName": "Pi",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cPI.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cPI.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "raichu-spring-2023",
        "name": "raichu-spring-2023",
        "displayName": "Spring 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cSPRING_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cSPRING_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "raichu-summer-2018",
        "name": "raichu-summer-2018",
        "displayName": "Summer 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cSUMMER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cSUMMER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "raichu-winter-2018",
        "name": "raichu-winter-2018",
        "displayName": "Winter 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cWINTER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm26.cWINTER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 27,
    "baseDexId": 27,
    "speciesName": "sandshrew",
    "forms": [
      {
        "formId": "sandshrew",
        "name": "sandshrew",
        "displayName": "Sandshrew",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/27.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/27.png",
        "isDefault": true
      },
      {
        "formId": "sandshrew-alola",
        "name": "sandshrew-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10101.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10101.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 28,
    "baseDexId": 28,
    "speciesName": "sandslash",
    "forms": [
      {
        "formId": "sandslash",
        "name": "sandslash",
        "displayName": "Sandslash",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/28.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/28.png",
        "isDefault": true
      },
      {
        "formId": "sandslash-alola",
        "name": "sandslash-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10102.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10102.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 31,
    "baseDexId": 31,
    "speciesName": "nidoqueen",
    "forms": [
      {
        "formId": "nidoqueen",
        "name": "nidoqueen",
        "displayName": "Nidoqueen",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/31.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/31.png",
        "isDefault": true
      },
      {
        "formId": "nidoqueen-royal",
        "name": "nidoqueen-royal",
        "displayName": "Royal",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm31.cROYAL_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm31.cROYAL_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 33,
    "baseDexId": 33,
    "speciesName": "nidorino",
    "forms": [
      {
        "formId": "nidorino",
        "name": "nidorino",
        "displayName": "Nidorino",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/33.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/33.png",
        "isDefault": true
      },
      {
        "formId": "nidorino-jan-2020",
        "name": "nidorino-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm33.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm33.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 34,
    "baseDexId": 34,
    "speciesName": "nidoking",
    "forms": [
      {
        "formId": "nidoking",
        "name": "nidoking",
        "displayName": "Nidoking",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/34.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/34.png",
        "isDefault": true
      },
      {
        "formId": "nidoking-royal",
        "name": "nidoking-royal",
        "displayName": "Royal",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm34.cROYAL_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm34.cROYAL_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 37,
    "baseDexId": 37,
    "speciesName": "vulpix",
    "forms": [
      {
        "formId": "vulpix",
        "name": "vulpix",
        "displayName": "Vulpix",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/37.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/37.png",
        "isDefault": true
      },
      {
        "formId": "vulpix-alola",
        "name": "vulpix-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10103.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10103.png",
        "isDefault": true
      },
      {
        "formId": "vulpix-fall-2022",
        "name": "vulpix-fall-2022",
        "displayName": "Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm37.cFALL_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm37.cFALL_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 38,
    "baseDexId": 38,
    "speciesName": "ninetales",
    "forms": [
      {
        "formId": "ninetales",
        "name": "ninetales",
        "displayName": "Ninetales",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/38.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/38.png",
        "isDefault": true
      },
      {
        "formId": "ninetales-alola",
        "name": "ninetales-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10104.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10104.png",
        "isDefault": true
      },
      {
        "formId": "ninetales-fall-2022",
        "name": "ninetales-fall-2022",
        "displayName": "Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm38.cFALL_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm38.cFALL_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 39,
    "baseDexId": 39,
    "speciesName": "jigglypuff",
    "forms": [
      {
        "formId": "jigglypuff",
        "name": "jigglypuff",
        "displayName": "Jigglypuff",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/39.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/39.png",
        "isDefault": true
      },
      {
        "formId": "jigglypuff-jan-2024",
        "name": "jigglypuff-jan-2024",
        "displayName": "Jan 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm39.cJAN_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm39.cJAN_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 40,
    "baseDexId": 40,
    "speciesName": "wigglytuff",
    "forms": [
      {
        "formId": "wigglytuff",
        "name": "wigglytuff",
        "displayName": "Wigglytuff",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/40.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/40.png",
        "isDefault": true
      },
      {
        "formId": "wigglytuff-jan-2024",
        "name": "wigglytuff-jan-2024",
        "displayName": "Jan 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm40.cJAN_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm40.cJAN_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 41,
    "baseDexId": 41,
    "speciesName": "zubat",
    "forms": [
      {
        "formId": "zubat",
        "name": "zubat",
        "displayName": "Zubat",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/41.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/41.png",
        "isDefault": true
      },
      {
        "formId": "zubat-halloween-2026",
        "name": "zubat-halloween-2026",
        "displayName": "Halloween 2026",
        "spritePath": "https://sprites.nexusdex.ai/curated/pm41.fHALLOWEEN_2026.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/curated/pm41.fHALLOWEEN_2026.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 50,
    "baseDexId": 50,
    "speciesName": "diglett",
    "forms": [
      {
        "formId": "diglett",
        "name": "diglett",
        "displayName": "Diglett",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/50.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/50.png",
        "isDefault": true
      },
      {
        "formId": "diglett-alola",
        "name": "diglett-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10105.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10105.png",
        "isDefault": true
      },
      {
        "formId": "diglett-fall-2022",
        "name": "diglett-fall-2022",
        "displayName": "Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm50.cFALL_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm50.cFALL_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 51,
    "baseDexId": 51,
    "speciesName": "dugtrio",
    "forms": [
      {
        "formId": "dugtrio",
        "name": "dugtrio",
        "displayName": "Dugtrio",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/51.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/51.png",
        "isDefault": true
      },
      {
        "formId": "dugtrio-alola",
        "name": "dugtrio-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10106.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10106.png",
        "isDefault": true
      },
      {
        "formId": "dugtrio-fall-2022",
        "name": "dugtrio-fall-2022",
        "displayName": "Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm51.cFALL_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm51.cFALL_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 52,
    "baseDexId": 52,
    "speciesName": "meowth",
    "forms": [
      {
        "formId": "meowth",
        "name": "meowth",
        "displayName": "Meowth",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/52.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/52.png",
        "isDefault": true
      },
      {
        "formId": "meowth-alola",
        "name": "meowth-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10107.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10107.png",
        "isDefault": true
      },
      {
        "formId": "meowth-galar",
        "name": "meowth-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10161.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10161.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 53,
    "baseDexId": 53,
    "speciesName": "persian",
    "forms": [
      {
        "formId": "persian",
        "name": "persian",
        "displayName": "Persian",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/53.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/53.png",
        "isDefault": true
      },
      {
        "formId": "persian-alola",
        "name": "persian-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10108.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10108.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 54,
    "baseDexId": 54,
    "speciesName": "psyduck",
    "forms": [
      {
        "formId": "psyduck",
        "name": "psyduck",
        "displayName": "Psyduck",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/54.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/54.png",
        "isDefault": true
      },
      {
        "formId": "psyduck-holiday-2023",
        "name": "psyduck-holiday-2023",
        "displayName": "Holiday 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm54.cHOLIDAY_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm54.cHOLIDAY_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "psyduck-swim-2025",
        "name": "psyduck-swim-2025",
        "displayName": "Swim 2025",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm54.fSWIM_2025.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm54.fSWIM_2025.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 55,
    "baseDexId": 55,
    "speciesName": "golduck",
    "forms": [
      {
        "formId": "golduck",
        "name": "golduck",
        "displayName": "Golduck",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/55.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/55.png",
        "isDefault": true
      },
      {
        "formId": "golduck-holiday-2023",
        "name": "golduck-holiday-2023",
        "displayName": "Holiday 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm55.cHOLIDAY_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm55.cHOLIDAY_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 58,
    "baseDexId": 58,
    "speciesName": "growlithe",
    "forms": [
      {
        "formId": "growlithe",
        "name": "growlithe",
        "displayName": "Growlithe",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/58.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/58.png",
        "isDefault": true
      },
      {
        "formId": "growlithe-hisui",
        "name": "growlithe-hisui",
        "displayName": "Hisui",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10229.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10229.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 59,
    "baseDexId": 59,
    "speciesName": "arcanine",
    "forms": [
      {
        "formId": "arcanine",
        "name": "arcanine",
        "displayName": "Arcanine",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/59.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/59.png",
        "isDefault": true
      },
      {
        "formId": "arcanine-hisui",
        "name": "arcanine-hisui",
        "displayName": "Hisui",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10230.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10230.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 68,
    "baseDexId": 68,
    "speciesName": "machamp",
    "forms": [
      {
        "formId": "machamp",
        "name": "machamp",
        "displayName": "Machamp",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/68.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/68.png",
        "isDefault": true
      },
      {
        "formId": "machamp-wildarea-2026",
        "name": "machamp-wildarea-2026",
        "displayName": "Modern Jacket",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm68.fWILDAREA_2026_01.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm68.fWILDAREA_2026_01.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 74,
    "baseDexId": 74,
    "speciesName": "geodude",
    "forms": [
      {
        "formId": "geodude",
        "name": "geodude",
        "displayName": "Geodude",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/74.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/74.png",
        "isDefault": true
      },
      {
        "formId": "geodude-alola",
        "name": "geodude-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10109.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10109.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 75,
    "baseDexId": 75,
    "speciesName": "graveler",
    "forms": [
      {
        "formId": "graveler",
        "name": "graveler",
        "displayName": "Graveler",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/75.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/75.png",
        "isDefault": true
      },
      {
        "formId": "graveler-alola",
        "name": "graveler-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10110.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10110.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 76,
    "baseDexId": 76,
    "speciesName": "golem",
    "forms": [
      {
        "formId": "golem",
        "name": "golem",
        "displayName": "Golem",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/76.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/76.png",
        "isDefault": true
      },
      {
        "formId": "golem-alola",
        "name": "golem-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10111.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10111.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 77,
    "baseDexId": 77,
    "speciesName": "ponyta",
    "forms": [
      {
        "formId": "ponyta",
        "name": "ponyta",
        "displayName": "Ponyta",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/77.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/77.png",
        "isDefault": true
      },
      {
        "formId": "ponyta-galar",
        "name": "ponyta-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10162.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10162.png",
        "isDefault": true
      },
      {
        "formId": "ponyta-galarian-gofest-2021",
        "name": "ponyta-galarian-gofest-2021",
        "displayName": "Galarian Gofest 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm77.fGALARIAN.cGOFEST_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm77.fGALARIAN.cGOFEST_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "ponyta-spring-2023-valor",
        "name": "ponyta-spring-2023-valor",
        "displayName": "Spring 2023 Valor",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm77.cSPRING_2023_VALOR.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm77.cSPRING_2023_VALOR.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 78,
    "baseDexId": 78,
    "speciesName": "rapidash",
    "forms": [
      {
        "formId": "rapidash",
        "name": "rapidash",
        "displayName": "Rapidash",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/78.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/78.png",
        "isDefault": true
      },
      {
        "formId": "rapidash-galar",
        "name": "rapidash-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10163.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10163.png",
        "isDefault": true
      },
      {
        "formId": "rapidash-spring-2023-valor",
        "name": "rapidash-spring-2023-valor",
        "displayName": "Spring 2023 Valor",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm78.cSPRING_2023_VALOR.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm78.cSPRING_2023_VALOR.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 79,
    "baseDexId": 79,
    "speciesName": "slowpoke",
    "forms": [
      {
        "formId": "slowpoke",
        "name": "slowpoke",
        "displayName": "Slowpoke",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/79.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/79.png",
        "isDefault": true
      },
      {
        "formId": "slowpoke-galar",
        "name": "slowpoke-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10164.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10164.png",
        "isDefault": true
      },
      {
        "formId": "slowpoke-pi",
        "name": "slowpoke-pi",
        "displayName": "Pi",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm79.cPI_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm79.cPI_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 80,
    "baseDexId": 80,
    "speciesName": "slowbro",
    "forms": [
      {
        "formId": "slowbro",
        "name": "slowbro",
        "displayName": "Slowbro",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/80.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/80.png",
        "isDefault": true
      },
      {
        "formId": "slowbro-galar",
        "name": "slowbro-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10165.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10165.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 83,
    "baseDexId": 83,
    "speciesName": "farfetchd",
    "forms": [
      {
        "formId": "farfetchd",
        "name": "farfetchd",
        "displayName": "Farfetchd",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/83.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/83.png",
        "isDefault": true
      },
      {
        "formId": "farfetchd-galar",
        "name": "farfetchd-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10166.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10166.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 88,
    "baseDexId": 88,
    "speciesName": "grimer",
    "forms": [
      {
        "formId": "grimer",
        "name": "grimer",
        "displayName": "Grimer",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/88.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/88.png",
        "isDefault": true
      },
      {
        "formId": "grimer-alola",
        "name": "grimer-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10112.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10112.png",
        "isDefault": true
      },
      {
        "formId": "grimer-anniversary-2024",
        "name": "grimer-anniversary-2024",
        "displayName": "Anniversary 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm88.cANNIVERSARY_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm88.cANNIVERSARY_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 89,
    "baseDexId": 89,
    "speciesName": "muk",
    "forms": [
      {
        "formId": "muk",
        "name": "muk",
        "displayName": "Muk",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/89.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/89.png",
        "isDefault": true
      },
      {
        "formId": "muk-alola",
        "name": "muk-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10113.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10113.png",
        "isDefault": true
      },
      {
        "formId": "muk-anniversary-2024",
        "name": "muk-anniversary-2024",
        "displayName": "Anniversary 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm89.cANNIVERSARY_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm89.cANNIVERSARY_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 94,
    "baseDexId": 94,
    "speciesName": "gengar",
    "forms": [
      {
        "formId": "gengar",
        "name": "gengar",
        "displayName": "Gengar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/94.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/94.png",
        "isDefault": true
      },
      {
        "formId": "gengar-costume-2020",
        "name": "gengar-costume-2020",
        "displayName": "Costume 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm94.fCOSTUME_2020.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm94.fCOSTUME_2020.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "gengar-fall-2022",
        "name": "gengar-fall-2022",
        "displayName": "Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm94.cFALL_2022_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm94.cFALL_2022_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "gengar-fall-2023",
        "name": "gengar-fall-2023",
        "displayName": "Fall 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm94.cFALL_2023_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm94.cFALL_2023_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "gengar-jan-2020",
        "name": "gengar-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm94.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm94.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 100,
    "baseDexId": 100,
    "speciesName": "voltorb",
    "forms": [
      {
        "formId": "voltorb",
        "name": "voltorb",
        "displayName": "Voltorb",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/100.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/100.png",
        "isDefault": true
      },
      {
        "formId": "voltorb-hisui",
        "name": "voltorb-hisui",
        "displayName": "Hisui",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10231.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10231.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 101,
    "baseDexId": 101,
    "speciesName": "electrode",
    "forms": [
      {
        "formId": "electrode",
        "name": "electrode",
        "displayName": "Electrode",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/101.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/101.png",
        "isDefault": true
      },
      {
        "formId": "electrode-hisui",
        "name": "electrode-hisui",
        "displayName": "Hisui",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10232.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10232.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 103,
    "baseDexId": 103,
    "speciesName": "exeggutor",
    "forms": [
      {
        "formId": "exeggutor",
        "name": "exeggutor",
        "displayName": "Exeggutor",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/103.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/103.png",
        "isDefault": true
      },
      {
        "formId": "exeggutor-alola",
        "name": "exeggutor-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10114.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10114.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 104,
    "baseDexId": 104,
    "speciesName": "cubone",
    "forms": [
      {
        "formId": "cubone",
        "name": "cubone",
        "displayName": "Cubone",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/104.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/104.png",
        "isDefault": true
      },
      {
        "formId": "cubone-fall-2023",
        "name": "cubone-fall-2023",
        "displayName": "Fall 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm104.cFALL_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm104.cFALL_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 105,
    "baseDexId": 105,
    "speciesName": "marowak",
    "forms": [
      {
        "formId": "marowak",
        "name": "marowak",
        "displayName": "Marowak",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/105.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/105.png",
        "isDefault": true
      },
      {
        "formId": "marowak-alola",
        "name": "marowak-alola",
        "displayName": "Alola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10115.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10115.png",
        "isDefault": true
      },
      {
        "formId": "marowak-fall-2023",
        "name": "marowak-fall-2023",
        "displayName": "Fall 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm105.cFALL_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm105.cFALL_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 110,
    "baseDexId": 110,
    "speciesName": "weezing",
    "forms": [
      {
        "formId": "weezing",
        "name": "weezing",
        "displayName": "Weezing",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/110.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/110.png",
        "isDefault": true
      },
      {
        "formId": "weezing-galar",
        "name": "weezing-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10167.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10167.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 113,
    "baseDexId": 113,
    "speciesName": "chansey",
    "forms": [
      {
        "formId": "chansey",
        "name": "chansey",
        "displayName": "Chansey",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/113.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/113.png",
        "isDefault": true
      },
      {
        "formId": "chansey-november-2018",
        "name": "chansey-november-2018",
        "displayName": "November 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm113.cNOVEMBER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm113.cNOVEMBER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 122,
    "baseDexId": 122,
    "speciesName": "mr-mime",
    "forms": [
      {
        "formId": "mr-mime",
        "name": "mr-mime",
        "displayName": "Mr Mime",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/122.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/122.png",
        "isDefault": true
      },
      {
        "formId": "mr-mime-galar",
        "name": "mr-mime-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10168.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10168.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 125,
    "baseDexId": 125,
    "speciesName": "electabuzz",
    "forms": [
      {
        "formId": "electabuzz",
        "name": "electabuzz",
        "displayName": "Electabuzz",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/125.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/125.png",
        "isDefault": true
      },
      {
        "formId": "electabuzz-spring-2023-instinct",
        "name": "electabuzz-spring-2023-instinct",
        "displayName": "Spring 2023 Instinct",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm125.cSPRING_2023_INSTINCT.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm125.cSPRING_2023_INSTINCT.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 128,
    "baseDexId": 128,
    "speciesName": "tauros",
    "forms": [
      {
        "formId": "tauros",
        "name": "tauros",
        "displayName": "Tauros",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/128.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/128.png",
        "isDefault": true
      },
      {
        "formId": "tauros-paldea-combat-breed",
        "name": "tauros-paldea-combat-breed",
        "displayName": "Paldea Combat Breed",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10250.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10250.png",
        "isDefault": true
      },
      {
        "formId": "tauros-paldea-blaze-breed",
        "name": "tauros-paldea-blaze-breed",
        "displayName": "Paldea Blaze Breed",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10251.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10251.png",
        "isDefault": true
      },
      {
        "formId": "tauros-paldea-aqua-breed",
        "name": "tauros-paldea-aqua-breed",
        "displayName": "Paldea Aqua Breed",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10252.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10252.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 131,
    "baseDexId": 131,
    "speciesName": "lapras",
    "forms": [
      {
        "formId": "lapras",
        "name": "lapras",
        "displayName": "Lapras",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/131.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/131.png",
        "isDefault": true
      },
      {
        "formId": "lapras-costume-2020",
        "name": "lapras-costume-2020",
        "displayName": "Costume 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm131.fCOSTUME_2020.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm131.fCOSTUME_2020.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "lapras-spring-2023-mystic",
        "name": "lapras-spring-2023-mystic",
        "displayName": "Spring 2023 Mystic",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm131.cSPRING_2023_MYSTIC.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm131.cSPRING_2023_MYSTIC.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 132,
    "baseDexId": 132,
    "speciesName": "ditto",
    "forms": [
      {
        "formId": "ditto",
        "name": "ditto",
        "displayName": "Ditto",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/132.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/132.png",
        "isDefault": true
      },
      {
        "formId": "ditto-spring-2026-a",
        "name": "ditto-spring-2026-a",
        "displayName": "Spring 2026 A",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm132.fSPRING_2026_A.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm132.fSPRING_2026_A.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "ditto-spring-2026-b",
        "name": "ditto-spring-2026-b",
        "displayName": "Spring 2026 B",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm132.fSPRING_2026_B.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm132.fSPRING_2026_B.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 133,
    "baseDexId": 133,
    "speciesName": "eevee",
    "forms": [
      {
        "formId": "eevee",
        "name": "eevee",
        "displayName": "Eevee",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/133.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/133.png",
        "isDefault": true
      },
      {
        "formId": "eevee-gofest-2024-mtiara",
        "name": "eevee-gofest-2024-mtiara",
        "displayName": "Gofest 2024 Mtiara",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm133.fGOFEST_2024_MTIARA.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm133.fGOFEST_2024_MTIARA.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "eevee-gofest-2024-stiara",
        "name": "eevee-gofest-2024-stiara",
        "displayName": "Gofest 2024 Stiara",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm133.fGOFEST_2024_STIARA.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm133.fGOFEST_2024_STIARA.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "eevee-holiday-2022",
        "name": "eevee-holiday-2022",
        "displayName": "Holiday 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm133.cHOLIDAY_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm133.cHOLIDAY_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "eevee-jan-2020",
        "name": "eevee-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm133.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm133.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "eevee-november-2018",
        "name": "eevee-november-2018",
        "displayName": "November 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm133.cNOVEMBER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm133.cNOVEMBER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "eevee-spring-2023",
        "name": "eevee-spring-2023",
        "displayName": "Spring 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm133.cSPRING_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm133.cSPRING_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 134,
    "baseDexId": 134,
    "speciesName": "vaporeon",
    "forms": [
      {
        "formId": "vaporeon",
        "name": "vaporeon",
        "displayName": "Vaporeon",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/134.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/134.png",
        "isDefault": true
      },
      {
        "formId": "vaporeon-holiday-2022",
        "name": "vaporeon-holiday-2022",
        "displayName": "Holiday 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm134.cHOLIDAY_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm134.cHOLIDAY_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "vaporeon-may-2023",
        "name": "vaporeon-may-2023",
        "displayName": "May 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm134.cMAY_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm134.cMAY_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "vaporeon-november-2018",
        "name": "vaporeon-november-2018",
        "displayName": "November 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm134.cNOVEMBER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm134.cNOVEMBER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "vaporeon-spring-2023",
        "name": "vaporeon-spring-2023",
        "displayName": "Spring 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm134.cSPRING_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm134.cSPRING_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 135,
    "baseDexId": 135,
    "speciesName": "jolteon",
    "forms": [
      {
        "formId": "jolteon",
        "name": "jolteon",
        "displayName": "Jolteon",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/135.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/135.png",
        "isDefault": true
      },
      {
        "formId": "jolteon-holiday-2022",
        "name": "jolteon-holiday-2022",
        "displayName": "Holiday 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm135.cHOLIDAY_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm135.cHOLIDAY_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "jolteon-may-2023",
        "name": "jolteon-may-2023",
        "displayName": "May 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm135.cMAY_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm135.cMAY_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "jolteon-november-2018",
        "name": "jolteon-november-2018",
        "displayName": "November 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm135.cNOVEMBER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm135.cNOVEMBER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "jolteon-spring-2023",
        "name": "jolteon-spring-2023",
        "displayName": "Spring 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm135.cSPRING_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm135.cSPRING_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 136,
    "baseDexId": 136,
    "speciesName": "flareon",
    "forms": [
      {
        "formId": "flareon",
        "name": "flareon",
        "displayName": "Flareon",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/136.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/136.png",
        "isDefault": true
      },
      {
        "formId": "flareon-holiday-2022",
        "name": "flareon-holiday-2022",
        "displayName": "Holiday 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm136.cHOLIDAY_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm136.cHOLIDAY_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "flareon-may-2023",
        "name": "flareon-may-2023",
        "displayName": "May 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm136.cMAY_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm136.cMAY_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "flareon-november-2018",
        "name": "flareon-november-2018",
        "displayName": "November 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm136.cNOVEMBER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm136.cNOVEMBER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "flareon-spring-2023",
        "name": "flareon-spring-2023",
        "displayName": "Spring 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm136.cSPRING_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm136.cSPRING_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 142,
    "baseDexId": 142,
    "speciesName": "aerodactyl",
    "forms": [
      {
        "formId": "aerodactyl",
        "name": "aerodactyl",
        "displayName": "Aerodactyl",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/142.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/142.png",
        "isDefault": true
      },
      {
        "formId": "aerodactyl-summer-2023",
        "name": "aerodactyl-summer-2023",
        "displayName": "Summer 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm142.fSUMMER_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm142.fSUMMER_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 143,
    "baseDexId": 143,
    "speciesName": "snorlax",
    "forms": [
      {
        "formId": "snorlax",
        "name": "snorlax",
        "displayName": "Snorlax",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/143.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/143.png",
        "isDefault": true
      },
      {
        "formId": "snorlax-gofest-2022",
        "name": "snorlax-gofest-2022",
        "displayName": "Gofest 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm143.cGOFEST_2022_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm143.cGOFEST_2022_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "snorlax-nightcap",
        "name": "snorlax-nightcap",
        "displayName": "Nightcap",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm143.cNIGHTCAP.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm143.cNIGHTCAP.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "snorlax-wildarea-2024",
        "name": "snorlax-wildarea-2024",
        "displayName": "Wildarea 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm143.fWILDAREA_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm143.fWILDAREA_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 144,
    "baseDexId": 144,
    "speciesName": "articuno",
    "forms": [
      {
        "formId": "articuno",
        "name": "articuno",
        "displayName": "Articuno",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/144.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/144.png",
        "isDefault": true
      },
      {
        "formId": "articuno-galar",
        "name": "articuno-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10169.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10169.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 145,
    "baseDexId": 145,
    "speciesName": "zapdos",
    "forms": [
      {
        "formId": "zapdos",
        "name": "zapdos",
        "displayName": "Zapdos",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/145.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/145.png",
        "isDefault": true
      },
      {
        "formId": "zapdos-galar",
        "name": "zapdos-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10170.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10170.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 146,
    "baseDexId": 146,
    "speciesName": "moltres",
    "forms": [
      {
        "formId": "moltres",
        "name": "moltres",
        "displayName": "Moltres",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/146.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/146.png",
        "isDefault": true
      },
      {
        "formId": "moltres-galar",
        "name": "moltres-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10171.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10171.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 149,
    "baseDexId": 149,
    "speciesName": "dragonite",
    "forms": [
      {
        "formId": "dragonite",
        "name": "dragonite",
        "displayName": "Dragonite",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/149.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/149.png",
        "isDefault": true
      },
      {
        "formId": "dragonite-fall-2023",
        "name": "dragonite-fall-2023",
        "displayName": "Fall 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm149.cFALL_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm149.cFALL_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 150,
    "baseDexId": 150,
    "speciesName": "mewtwo",
    "forms": [
      {
        "formId": "mewtwo",
        "name": "mewtwo",
        "displayName": "Mewtwo",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/150.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/150.png",
        "isDefault": true
      },
      {
        "formId": "mewtwo-armored",
        "name": "mewtwo-armored",
        "displayName": "Armored",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm150.fA.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm150.fA.s.icon.png",
        "isDefault": false,
        "shinyReleased": false
      },
      {
        "formId": "mewtwo-one-year-anniversary",
        "name": "mewtwo-one-year-anniversary",
        "displayName": "One Year Anniversary",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm150.cONE_YEAR_ANNIVERSARY.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm150.cONE_YEAR_ANNIVERSARY.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 157,
    "baseDexId": 157,
    "speciesName": "typhlosion",
    "forms": [
      {
        "formId": "typhlosion",
        "name": "typhlosion",
        "displayName": "Typhlosion",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/157.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/157.png",
        "isDefault": true
      },
      {
        "formId": "typhlosion-hisui",
        "name": "typhlosion-hisui",
        "displayName": "Hisui",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10233.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10233.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 163,
    "baseDexId": 163,
    "speciesName": "hoothoot",
    "forms": [
      {
        "formId": "hoothoot",
        "name": "hoothoot",
        "displayName": "Hoothoot",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/163.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/163.png",
        "isDefault": true
      },
      {
        "formId": "hoothoot-jan-2022",
        "name": "hoothoot-jan-2022",
        "displayName": "Jan 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm163.cJAN_2022_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm163.cJAN_2022_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 164,
    "baseDexId": 164,
    "speciesName": "noctowl",
    "forms": [
      {
        "formId": "noctowl",
        "name": "noctowl",
        "displayName": "Noctowl",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/164.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/164.png",
        "isDefault": true
      },
      {
        "formId": "noctowl-jan-2022",
        "name": "noctowl-jan-2022",
        "displayName": "Jan 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm164.cJAN_2022_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm164.cJAN_2022_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 172,
    "baseDexId": 172,
    "speciesName": "pichu",
    "forms": [
      {
        "formId": "pichu",
        "name": "pichu",
        "displayName": "Pichu",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/172.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/172.png",
        "isDefault": true
      },
      {
        "formId": "pichu-anniversary",
        "name": "pichu-anniversary",
        "displayName": "Anniversary",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cANNIVERSARY.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cANNIVERSARY.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pichu-costume-2",
        "name": "pichu-costume-2",
        "displayName": "Costume 2",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cCOSTUME_2.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cCOSTUME_2.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pichu-fall-2018",
        "name": "pichu-fall-2018",
        "displayName": "Fall 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cFALL_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cFALL_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pichu-halloween-2017",
        "name": "pichu-halloween-2017",
        "displayName": "Halloween 2017",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cHALLOWEEN_2017.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cHALLOWEEN_2017.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pichu-holiday-2016",
        "name": "pichu-holiday-2016",
        "displayName": "Holiday 2016",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cHOLIDAY_2016.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cHOLIDAY_2016.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pichu-november-2018",
        "name": "pichu-november-2018",
        "displayName": "November 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cNOVEMBER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cNOVEMBER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pichu-one-year-anniversary",
        "name": "pichu-one-year-anniversary",
        "displayName": "One Year Anniversary",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cONE_YEAR_ANNIVERSARY.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cONE_YEAR_ANNIVERSARY.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pichu-spring-2023",
        "name": "pichu-spring-2023",
        "displayName": "Spring 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cSPRING_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cSPRING_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pichu-summer-2018",
        "name": "pichu-summer-2018",
        "displayName": "Summer 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cSUMMER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cSUMMER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pichu-winter-2018",
        "name": "pichu-winter-2018",
        "displayName": "Winter 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cWINTER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm172.cWINTER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 175,
    "baseDexId": 175,
    "speciesName": "togepi",
    "forms": [
      {
        "formId": "togepi",
        "name": "togepi",
        "displayName": "Togepi",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/175.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/175.png",
        "isDefault": true
      },
      {
        "formId": "togepi-april-2020",
        "name": "togepi-april-2020",
        "displayName": "April 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm175.cAPRIL_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm175.cAPRIL_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 176,
    "baseDexId": 176,
    "speciesName": "togetic",
    "forms": [
      {
        "formId": "togetic",
        "name": "togetic",
        "displayName": "Togetic",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/176.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/176.png",
        "isDefault": true
      },
      {
        "formId": "togetic-april-2020",
        "name": "togetic-april-2020",
        "displayName": "April 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm176.cAPRIL_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm176.cAPRIL_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 185,
    "baseDexId": 185,
    "speciesName": "sudowoodo",
    "forms": [
      {
        "formId": "sudowoodo",
        "name": "sudowoodo",
        "displayName": "Sudowoodo",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/185.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/185.png",
        "isDefault": true
      },
      {
        "formId": "sudowoodo-winter-2025",
        "name": "sudowoodo-winter-2025",
        "displayName": "Winter 2025",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm185.fWINTER_2025.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm185.fWINTER_2025.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 194,
    "baseDexId": 194,
    "speciesName": "wooper",
    "forms": [
      {
        "formId": "wooper",
        "name": "wooper",
        "displayName": "Wooper",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/194.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/194.png",
        "isDefault": true
      },
      {
        "formId": "wooper-paldea",
        "name": "wooper-paldea",
        "displayName": "Paldea",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10253.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10253.png",
        "isDefault": true
      },
      {
        "formId": "wooper-fall-2023",
        "name": "wooper-fall-2023",
        "displayName": "Fall 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm194.cFALL_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm194.cFALL_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 195,
    "baseDexId": 195,
    "speciesName": "quagsire",
    "forms": [
      {
        "formId": "quagsire",
        "name": "quagsire",
        "displayName": "Quagsire",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/195.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/195.png",
        "isDefault": true
      },
      {
        "formId": "quagsire-fall-2023",
        "name": "quagsire-fall-2023",
        "displayName": "Fall 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm195.cFALL_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm195.cFALL_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 196,
    "baseDexId": 196,
    "speciesName": "espeon",
    "forms": [
      {
        "formId": "espeon",
        "name": "espeon",
        "displayName": "Espeon",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/196.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/196.png",
        "isDefault": true
      },
      {
        "formId": "espeon-gofest-2024-sscarf",
        "name": "espeon-gofest-2024-sscarf",
        "displayName": "Gofest 2024 Sscarf",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm196.fGOFEST_2024_SSCARF.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm196.fGOFEST_2024_SSCARF.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "espeon-holiday-2022",
        "name": "espeon-holiday-2022",
        "displayName": "Holiday 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm196.cHOLIDAY_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm196.cHOLIDAY_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "espeon-may-2023",
        "name": "espeon-may-2023",
        "displayName": "May 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm196.cMAY_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm196.cMAY_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "espeon-november-2018",
        "name": "espeon-november-2018",
        "displayName": "November 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm196.cNOVEMBER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm196.cNOVEMBER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "espeon-spring-2023",
        "name": "espeon-spring-2023",
        "displayName": "Spring 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm196.cSPRING_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm196.cSPRING_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 197,
    "baseDexId": 197,
    "speciesName": "umbreon",
    "forms": [
      {
        "formId": "umbreon",
        "name": "umbreon",
        "displayName": "Umbreon",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/197.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/197.png",
        "isDefault": true
      },
      {
        "formId": "umbreon-gofest-2024-mscarf",
        "name": "umbreon-gofest-2024-mscarf",
        "displayName": "Gofest 2024 Mscarf",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm197.fGOFEST_2024_MSCARF.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm197.fGOFEST_2024_MSCARF.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "umbreon-holiday-2022",
        "name": "umbreon-holiday-2022",
        "displayName": "Holiday 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm197.cHOLIDAY_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm197.cHOLIDAY_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "umbreon-may-2023",
        "name": "umbreon-may-2023",
        "displayName": "May 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm197.cMAY_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm197.cMAY_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "umbreon-november-2018",
        "name": "umbreon-november-2018",
        "displayName": "November 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm197.cNOVEMBER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm197.cNOVEMBER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "umbreon-spring-2023",
        "name": "umbreon-spring-2023",
        "displayName": "Spring 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm197.cSPRING_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm197.cSPRING_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 199,
    "baseDexId": 199,
    "speciesName": "slowking",
    "forms": [
      {
        "formId": "slowking",
        "name": "slowking",
        "displayName": "Slowking",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/199.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/199.png",
        "isDefault": true
      },
      {
        "formId": "slowking-galar",
        "name": "slowking-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10172.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10172.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 201,
    "baseDexId": 201,
    "speciesName": "unown",
    "forms": [
      {
        "formId": "unown-a",
        "name": "unown-a",
        "displayName": "A",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/201.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/201.png",
        "isDefault": true
      },
      {
        "formId": "unown-b",
        "name": "unown-b",
        "displayName": "B",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_B.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_B.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-c",
        "name": "unown-c",
        "displayName": "C",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_C.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_C.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-d",
        "name": "unown-d",
        "displayName": "D",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_D.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_D.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-e",
        "name": "unown-e",
        "displayName": "E",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_E.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_E.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-f",
        "name": "unown-f",
        "displayName": "F",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_F.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_F.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-g",
        "name": "unown-g",
        "displayName": "G",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_G.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_G.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-h",
        "name": "unown-h",
        "displayName": "H",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_H.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_H.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-i",
        "name": "unown-i",
        "displayName": "I",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_I.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_I.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-j",
        "name": "unown-j",
        "displayName": "J",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_J.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_J.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-k",
        "name": "unown-k",
        "displayName": "K",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_K.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_K.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-l",
        "name": "unown-l",
        "displayName": "L",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_L.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_L.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-m",
        "name": "unown-m",
        "displayName": "M",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_M.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_M.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-n",
        "name": "unown-n",
        "displayName": "N",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_N.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_N.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-o",
        "name": "unown-o",
        "displayName": "O",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_O.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_O.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-p",
        "name": "unown-p",
        "displayName": "P",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_P.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_P.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-q",
        "name": "unown-q",
        "displayName": "Q",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_Q.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_Q.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-r",
        "name": "unown-r",
        "displayName": "R",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_R.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_R.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-s",
        "name": "unown-s",
        "displayName": "S",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_S.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_S.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-t",
        "name": "unown-t",
        "displayName": "T",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_T.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_T.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-u",
        "name": "unown-u",
        "displayName": "U",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_U.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_U.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-v",
        "name": "unown-v",
        "displayName": "V",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_V.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_V.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-w",
        "name": "unown-w",
        "displayName": "W",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_W.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_W.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-x",
        "name": "unown-x",
        "displayName": "X",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_X.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_X.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-y",
        "name": "unown-y",
        "displayName": "Y",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_Y.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_Y.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-z",
        "name": "unown-z",
        "displayName": "Z",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_Z.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_Z.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-exclamation",
        "name": "unown-exclamation",
        "displayName": "Exclamation",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_EXCLAMATION_POINT.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_EXCLAMATION_POINT.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "unown-question",
        "name": "unown-question",
        "displayName": "Question",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_QUESTION_MARK.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm201.fUNOWN_QUESTION_MARK.s.icon.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 202,
    "baseDexId": 202,
    "speciesName": "wobbuffet",
    "forms": [
      {
        "formId": "wobbuffet",
        "name": "wobbuffet",
        "displayName": "Wobbuffet",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/202.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/202.png",
        "isDefault": true
      },
      {
        "formId": "wobbuffet-jan-2020",
        "name": "wobbuffet-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm202.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm202.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 211,
    "baseDexId": 211,
    "speciesName": "qwilfish",
    "forms": [
      {
        "formId": "qwilfish",
        "name": "qwilfish",
        "displayName": "Qwilfish",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/211.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/211.png",
        "isDefault": true
      },
      {
        "formId": "qwilfish-hisui",
        "name": "qwilfish-hisui",
        "displayName": "Hisui",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10234.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10234.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 215,
    "baseDexId": 215,
    "speciesName": "sneasel",
    "forms": [
      {
        "formId": "sneasel",
        "name": "sneasel",
        "displayName": "Sneasel",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/215.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/215.png",
        "isDefault": true
      },
      {
        "formId": "sneasel-hisui",
        "name": "sneasel-hisui",
        "displayName": "Hisui",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10235.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10235.png",
        "isDefault": true
      },
      {
        "formId": "sneasel-fashion-2021",
        "name": "sneasel-fashion-2021",
        "displayName": "Fashion 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm215.cFASHION_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm215.cFASHION_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 216,
    "baseDexId": 216,
    "speciesName": "teddiursa",
    "forms": [
      {
        "formId": "teddiursa",
        "name": "teddiursa",
        "displayName": "Teddiursa",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/216.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/216.png",
        "isDefault": true
      },
      {
        "formId": "teddiursa-halloween-2025",
        "name": "teddiursa-halloween-2025",
        "displayName": "Halloween 2025",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm216.cHALLOWEEN_2025.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm216.cHALLOWEEN_2025.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 217,
    "baseDexId": 217,
    "speciesName": "ursaring",
    "forms": [
      {
        "formId": "ursaring",
        "name": "ursaring",
        "displayName": "Ursaring",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/217.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/217.png",
        "isDefault": true
      },
      {
        "formId": "ursaring-halloween-2025",
        "name": "ursaring-halloween-2025",
        "displayName": "Halloween 2025",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm217.cHALLOWEEN_2025.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm217.cHALLOWEEN_2025.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 222,
    "baseDexId": 222,
    "speciesName": "corsola",
    "forms": [
      {
        "formId": "corsola",
        "name": "corsola",
        "displayName": "Corsola",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/222.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/222.png",
        "isDefault": true
      },
      {
        "formId": "corsola-galar",
        "name": "corsola-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10173.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10173.png",
        "isDefault": true
      },
      {
        "formId": "corsola-spring-2026",
        "name": "corsola-spring-2026",
        "displayName": "Spring 2026",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm222.fSPRING_2026.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm222.fSPRING_2026.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 225,
    "baseDexId": 225,
    "speciesName": "delibird",
    "forms": [
      {
        "formId": "delibird",
        "name": "delibird",
        "displayName": "Delibird",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/225.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/225.png",
        "isDefault": true
      },
      {
        "formId": "delibird-winter-2020",
        "name": "delibird-winter-2020",
        "displayName": "Winter 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm225.fWINTER_2020.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm225.fWINTER_2020.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 234,
    "baseDexId": 234,
    "speciesName": "stantler",
    "forms": [
      {
        "formId": "stantler",
        "name": "stantler",
        "displayName": "Stantler",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/234.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/234.png",
        "isDefault": true
      },
      {
        "formId": "stantler-winter-2018",
        "name": "stantler-winter-2018",
        "displayName": "Winter 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm234.cWINTER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm234.cWINTER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 238,
    "baseDexId": 238,
    "speciesName": "smoochum",
    "forms": [
      {
        "formId": "smoochum",
        "name": "smoochum",
        "displayName": "Smoochum",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/238.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/238.png",
        "isDefault": true
      },
      {
        "formId": "smoochum-fall-2020",
        "name": "smoochum-fall-2020",
        "displayName": "Fall 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm238.cFALL_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm238.cFALL_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 239,
    "baseDexId": 239,
    "speciesName": "elekid",
    "forms": [
      {
        "formId": "elekid",
        "name": "elekid",
        "displayName": "Elekid",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/239.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/239.png",
        "isDefault": true
      },
      {
        "formId": "elekid-spring-2023-instinct",
        "name": "elekid-spring-2023-instinct",
        "displayName": "Spring 2023 Instinct",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm239.cSPRING_2023_INSTINCT.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm239.cSPRING_2023_INSTINCT.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 242,
    "baseDexId": 242,
    "speciesName": "blissey",
    "forms": [
      {
        "formId": "blissey",
        "name": "blissey",
        "displayName": "Blissey",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/242.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/242.png",
        "isDefault": true
      },
      {
        "formId": "blissey-november-2018",
        "name": "blissey-november-2018",
        "displayName": "November 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm242.cNOVEMBER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm242.cNOVEMBER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 249,
    "baseDexId": 249,
    "speciesName": "lugia",
    "forms": [
      {
        "formId": "lugia",
        "name": "lugia",
        "displayName": "Lugia",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/249.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/249.png",
        "isDefault": true
      },
      {
        "formId": "lugia-one-year-anniversary",
        "name": "lugia-one-year-anniversary",
        "displayName": "One Year Anniversary",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm249.cONE_YEAR_ANNIVERSARY.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm249.cONE_YEAR_ANNIVERSARY.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 263,
    "baseDexId": 263,
    "speciesName": "zigzagoon",
    "forms": [
      {
        "formId": "zigzagoon",
        "name": "zigzagoon",
        "displayName": "Zigzagoon",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/263.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/263.png",
        "isDefault": true
      },
      {
        "formId": "zigzagoon-galar",
        "name": "zigzagoon-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10174.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10174.png",
        "isDefault": true
      },
      {
        "formId": "zigzagoon-galarian-gofest-2021",
        "name": "zigzagoon-galarian-gofest-2021",
        "displayName": "Galarian Gofest 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm263.fGALARIAN.cGOFEST_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm263.fGALARIAN.cGOFEST_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 264,
    "baseDexId": 264,
    "speciesName": "linoone",
    "forms": [
      {
        "formId": "linoone",
        "name": "linoone",
        "displayName": "Linoone",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/264.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/264.png",
        "isDefault": true
      },
      {
        "formId": "linoone-galar",
        "name": "linoone-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10175.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10175.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 265,
    "baseDexId": 265,
    "speciesName": "wurmple",
    "forms": [
      {
        "formId": "wurmple",
        "name": "wurmple",
        "displayName": "Wurmple",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/265.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/265.png",
        "isDefault": true
      },
      {
        "formId": "wurmple-jan-2020",
        "name": "wurmple-jan-2020",
        "displayName": "Jan 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm265.cJAN_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm265.cJAN_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 281,
    "baseDexId": 281,
    "speciesName": "kirlia",
    "forms": [
      {
        "formId": "kirlia",
        "name": "kirlia",
        "displayName": "Kirlia",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/281.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/281.png",
        "isDefault": true
      },
      {
        "formId": "kirlia-fall-2020",
        "name": "kirlia-fall-2020",
        "displayName": "Fall 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm281.cFALL_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm281.cFALL_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 282,
    "baseDexId": 282,
    "speciesName": "gardevoir",
    "forms": [
      {
        "formId": "gardevoir",
        "name": "gardevoir",
        "displayName": "Gardevoir",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/282.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/282.png",
        "isDefault": true
      },
      {
        "formId": "gardevoir-gofest-2021",
        "name": "gardevoir-gofest-2021",
        "displayName": "Gofest 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm282.cGOFEST_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm282.cGOFEST_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 287,
    "baseDexId": 287,
    "speciesName": "slakoth",
    "forms": [
      {
        "formId": "slakoth",
        "name": "slakoth",
        "displayName": "Slakoth",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/287.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/287.png",
        "isDefault": true
      },
      {
        "formId": "slakoth-summer-2024",
        "name": "slakoth-summer-2024",
        "displayName": "Summer 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm287.cSUMMER_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm287.cSUMMER_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 288,
    "baseDexId": 288,
    "speciesName": "vigoroth",
    "forms": [
      {
        "formId": "vigoroth",
        "name": "vigoroth",
        "displayName": "Vigoroth",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/288.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/288.png",
        "isDefault": true
      },
      {
        "formId": "vigoroth-summer-2024",
        "name": "vigoroth-summer-2024",
        "displayName": "Summer 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm288.cSUMMER_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm288.cSUMMER_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 289,
    "baseDexId": 289,
    "speciesName": "slaking",
    "forms": [
      {
        "formId": "slaking",
        "name": "slaking",
        "displayName": "Slaking",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/289.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/289.png",
        "isDefault": true
      },
      {
        "formId": "slaking-summer-2024",
        "name": "slaking-summer-2024",
        "displayName": "Summer 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm289.cSUMMER_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm289.cSUMMER_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 302,
    "baseDexId": 302,
    "speciesName": "sableye",
    "forms": [
      {
        "formId": "sableye",
        "name": "sableye",
        "displayName": "Sableye",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/302.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/302.png",
        "isDefault": true
      },
      {
        "formId": "sableye-costume-2020",
        "name": "sableye-costume-2020",
        "displayName": "Costume 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm302.fCOSTUME_2020.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm302.fCOSTUME_2020.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 327,
    "baseDexId": 327,
    "speciesName": "spinda",
    "forms": [
      {
        "formId": "spinda-pattern-1",
        "name": "spinda-pattern-1",
        "displayName": "Pattern 1",
        "spritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/normal/spinda-01.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/shiny/spinda-01.png",
        "isDefault": true
      },
      {
        "formId": "spinda-pattern-2",
        "name": "spinda-pattern-2",
        "displayName": "Pattern 2",
        "spritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/normal/spinda-02.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/shiny/spinda-02.png",
        "isDefault": false
      },
      {
        "formId": "spinda-pattern-3",
        "name": "spinda-pattern-3",
        "displayName": "Pattern 3",
        "spritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/normal/spinda-03.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/shiny/spinda-03.png",
        "isDefault": false
      },
      {
        "formId": "spinda-pattern-4",
        "name": "spinda-pattern-4",
        "displayName": "Pattern 4",
        "spritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/normal/spinda-04.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/shiny/spinda-04.png",
        "isDefault": false
      },
      {
        "formId": "spinda-pattern-5",
        "name": "spinda-pattern-5",
        "displayName": "Pattern 5",
        "spritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/normal/spinda-05.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/shiny/spinda-05.png",
        "isDefault": false
      },
      {
        "formId": "spinda-pattern-6",
        "name": "spinda-pattern-6",
        "displayName": "Pattern 6",
        "spritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/normal/spinda-06.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/shiny/spinda-06.png",
        "isDefault": false
      },
      {
        "formId": "spinda-pattern-7",
        "name": "spinda-pattern-7",
        "displayName": "Pattern 7",
        "spritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/normal/spinda-07.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/shiny/spinda-07.png",
        "isDefault": false
      },
      {
        "formId": "spinda-pattern-8",
        "name": "spinda-pattern-8",
        "displayName": "Pattern 8",
        "spritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/normal/spinda-08.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/shiny/spinda-08.png",
        "isDefault": false
      },
      {
        "formId": "spinda-pattern-9",
        "name": "spinda-pattern-9",
        "displayName": "Pattern 9",
        "spritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/normal/spinda-09.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokemondb/sprites/go/shiny/spinda-09.png",
        "isDefault": false
      },
      {
        "formId": "spinda-pattern-10",
        "name": "spinda-pattern-10",
        "displayName": "Pattern 10",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/327.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/327.png",
        "isDefault": false,
        "isReleased": false
      },
      {
        "formId": "spinda-pattern-11",
        "name": "spinda-pattern-11",
        "displayName": "Pattern 11",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/327.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/327.png",
        "isDefault": false,
        "isReleased": false
      },
      {
        "formId": "spinda-pattern-12",
        "name": "spinda-pattern-12",
        "displayName": "Pattern 12",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/327.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/327.png",
        "isDefault": false,
        "isReleased": false
      },
      {
        "formId": "spinda-pattern-13",
        "name": "spinda-pattern-13",
        "displayName": "Pattern 13",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/327.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/327.png",
        "isDefault": false,
        "isReleased": false
      },
      {
        "formId": "spinda-pattern-14",
        "name": "spinda-pattern-14",
        "displayName": "Pattern 14",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/327.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/327.png",
        "isDefault": false,
        "isReleased": false
      },
      {
        "formId": "spinda-pattern-15",
        "name": "spinda-pattern-15",
        "displayName": "Pattern 15",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/327.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/327.png",
        "isDefault": false,
        "isReleased": false
      },
      {
        "formId": "spinda-pattern-16",
        "name": "spinda-pattern-16",
        "displayName": "Pattern 16",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/327.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/327.png",
        "isDefault": false,
        "isReleased": false
      },
      {
        "formId": "spinda-pattern-17",
        "name": "spinda-pattern-17",
        "displayName": "Pattern 17",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/327.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/327.png",
        "isDefault": false,
        "isReleased": false
      },
      {
        "formId": "spinda-pattern-18",
        "name": "spinda-pattern-18",
        "displayName": "Pattern 18",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/327.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/327.png",
        "isDefault": false,
        "isReleased": false
      },
      {
        "formId": "spinda-pattern-19",
        "name": "spinda-pattern-19",
        "displayName": "Pattern 19",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/327.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/327.png",
        "isDefault": false,
        "isReleased": false
      },
      {
        "formId": "spinda-pattern-20",
        "name": "spinda-pattern-20",
        "displayName": "Pattern 20",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/327.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/327.png",
        "isDefault": false,
        "isReleased": false
      }
    ]
  },
  {
    "speciesId": 330,
    "baseDexId": 330,
    "speciesName": "flygon",
    "forms": [
      {
        "formId": "flygon",
        "name": "flygon",
        "displayName": "Flygon",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/330.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/330.png",
        "isDefault": true
      },
      {
        "formId": "flygon-gofest-2021",
        "name": "flygon-gofest-2021",
        "displayName": "Gofest 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm330.cGOFEST_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm330.cGOFEST_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 351,
    "baseDexId": 351,
    "speciesName": "castform",
    "forms": [
      {
        "formId": "castform",
        "name": "castform",
        "displayName": "Castform",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/351.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/351.png",
        "isDefault": true
      },
      {
        "formId": "castform-sunny",
        "name": "castform-sunny",
        "displayName": "Sunny",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10013.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10013.png",
        "isDefault": true
      },
      {
        "formId": "castform-rainy",
        "name": "castform-rainy",
        "displayName": "Rainy",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10014.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10014.png",
        "isDefault": true
      },
      {
        "formId": "castform-snowy",
        "name": "castform-snowy",
        "displayName": "Snowy",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10015.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10015.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 355,
    "baseDexId": 355,
    "speciesName": "duskull",
    "forms": [
      {
        "formId": "duskull",
        "name": "duskull",
        "displayName": "Duskull",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/355.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/355.png",
        "isDefault": true
      },
      {
        "formId": "duskull-fall-2022",
        "name": "duskull-fall-2022",
        "displayName": "Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm355.cFALL_2022_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm355.cFALL_2022_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 356,
    "baseDexId": 356,
    "speciesName": "dusclops",
    "forms": [
      {
        "formId": "dusclops",
        "name": "dusclops",
        "displayName": "Dusclops",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/356.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/356.png",
        "isDefault": true
      },
      {
        "formId": "dusclops-fall-2022",
        "name": "dusclops-fall-2022",
        "displayName": "Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm356.cFALL_2022_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm356.cFALL_2022_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 359,
    "baseDexId": 359,
    "speciesName": "absol",
    "forms": [
      {
        "formId": "absol",
        "name": "absol",
        "displayName": "Absol",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/359.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/359.png",
        "isDefault": true
      },
      {
        "formId": "absol-fall-2022",
        "name": "absol-fall-2022",
        "displayName": "Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm359.cFALL_2022_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm359.cFALL_2022_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 363,
    "baseDexId": 363,
    "speciesName": "spheal",
    "forms": [
      {
        "formId": "spheal",
        "name": "spheal",
        "displayName": "Spheal",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/363.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/363.png",
        "isDefault": true
      },
      {
        "formId": "spheal-holiday-2021",
        "name": "spheal-holiday-2021",
        "displayName": "Holiday 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm363.cHOLIDAY_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm363.cHOLIDAY_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 386,
    "baseDexId": 386,
    "speciesName": "deoxys",
    "forms": [
      {
        "formId": "deoxys-normal",
        "name": "deoxys-normal",
        "displayName": "Deoxys",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/386.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/386.png",
        "isDefault": true
      },
      {
        "formId": "deoxys-attack",
        "name": "deoxys-attack",
        "displayName": "Attack",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10001.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10001.png",
        "isDefault": true
      },
      {
        "formId": "deoxys-defense",
        "name": "deoxys-defense",
        "displayName": "Defense",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10002.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10002.png",
        "isDefault": true
      },
      {
        "formId": "deoxys-speed",
        "name": "deoxys-speed",
        "displayName": "Speed",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10003.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10003.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 387,
    "baseDexId": 387,
    "speciesName": "turtwig",
    "forms": [
      {
        "formId": "turtwig",
        "name": "turtwig",
        "displayName": "Turtwig",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/387.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/387.png",
        "isDefault": true
      },
      {
        "formId": "turtwig-gems-1-2021",
        "name": "turtwig-gems-1-2021",
        "displayName": "Gems 1 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm387.cGEMS_1_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm387.cGEMS_1_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "turtwig-gems-2-2021",
        "name": "turtwig-gems-2-2021",
        "displayName": "Gems 2 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm387.cGEMS_2_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm387.cGEMS_2_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 390,
    "baseDexId": 390,
    "speciesName": "chimchar",
    "forms": [
      {
        "formId": "chimchar",
        "name": "chimchar",
        "displayName": "Chimchar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/390.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/390.png",
        "isDefault": true
      },
      {
        "formId": "chimchar-gems-1-2021",
        "name": "chimchar-gems-1-2021",
        "displayName": "Gems 1 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm390.cGEMS_1_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm390.cGEMS_1_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "chimchar-gems-2-2021",
        "name": "chimchar-gems-2-2021",
        "displayName": "Gems 2 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm390.cGEMS_2_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm390.cGEMS_2_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 393,
    "baseDexId": 393,
    "speciesName": "piplup",
    "forms": [
      {
        "formId": "piplup",
        "name": "piplup",
        "displayName": "Piplup",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/393.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/393.png",
        "isDefault": true
      },
      {
        "formId": "piplup-gems-1-2021",
        "name": "piplup-gems-1-2021",
        "displayName": "Gems 1 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm393.cGEMS_1_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm393.cGEMS_1_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "piplup-gems-2-2021",
        "name": "piplup-gems-2-2021",
        "displayName": "Gems 2 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm393.cGEMS_2_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm393.cGEMS_2_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "piplup-halloween-2021",
        "name": "piplup-halloween-2021",
        "displayName": "Halloween 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm393.cHALLOWEEN_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm393.cHALLOWEEN_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 403,
    "baseDexId": 403,
    "speciesName": "shinx",
    "forms": [
      {
        "formId": "shinx",
        "name": "shinx",
        "displayName": "Shinx",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/403.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/403.png",
        "isDefault": true
      },
      {
        "formId": "shinx-fall-2020",
        "name": "shinx-fall-2020",
        "displayName": "Fall 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm403.cFALL_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm403.cFALL_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 412,
    "baseDexId": 412,
    "speciesName": "burmy",
    "forms": [
      {
        "formId": "burmy-plant",
        "name": "burmy-plant",
        "displayName": "Plant",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/412.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/412.png",
        "isDefault": true
      },
      {
        "formId": "burmy-sandy",
        "name": "burmy-sandy",
        "displayName": "Sandy",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm412.fBURMY_SANDY.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm412.fBURMY_SANDY.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "burmy-trash",
        "name": "burmy-trash",
        "displayName": "Trash",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm412.fBURMY_TRASH.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm412.fBURMY_TRASH.s.icon.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 413,
    "baseDexId": 413,
    "speciesName": "wormadam",
    "forms": [
      {
        "formId": "wormadam-plant",
        "name": "wormadam-plant",
        "displayName": "Plant",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/413.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/413.png",
        "isDefault": true
      },
      {
        "formId": "wormadam-sandy",
        "name": "wormadam-sandy",
        "displayName": "Sandy",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10004.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10004.png",
        "isDefault": true
      },
      {
        "formId": "wormadam-trash",
        "name": "wormadam-trash",
        "displayName": "Trash",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10005.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10005.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 421,
    "baseDexId": 421,
    "speciesName": "cherrim",
    "forms": [
      {
        "formId": "cherrim-overcast",
        "name": "cherrim-overcast",
        "displayName": "Overcast",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/421.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/421.png",
        "isDefault": true
      },
      {
        "formId": "cherrim-sunshine",
        "name": "cherrim-sunshine",
        "displayName": "Sunshine",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm421.fSUNNY.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm421.fSUNNY.s.icon.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 422,
    "baseDexId": 422,
    "speciesName": "shellos",
    "forms": [
      {
        "formId": "shellos-west",
        "name": "shellos-west",
        "displayName": "West",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/422.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/422.png",
        "isDefault": true
      },
      {
        "formId": "shellos-east",
        "name": "shellos-east",
        "displayName": "East",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm422.fEAST_SEA.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm422.fEAST_SEA.s.icon.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 423,
    "baseDexId": 423,
    "speciesName": "gastrodon",
    "forms": [
      {
        "formId": "gastrodon-west",
        "name": "gastrodon-west",
        "displayName": "West",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/423.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/423.png",
        "isDefault": true
      },
      {
        "formId": "gastrodon-east",
        "name": "gastrodon-east",
        "displayName": "East",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm423.fEAST_SEA.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm423.fEAST_SEA.s.icon.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 426,
    "baseDexId": 426,
    "speciesName": "drifblim",
    "forms": [
      {
        "formId": "drifblim",
        "name": "drifblim",
        "displayName": "Drifblim",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/426.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/426.png",
        "isDefault": true
      },
      {
        "formId": "drifblim-halloween-2021",
        "name": "drifblim-halloween-2021",
        "displayName": "Halloween 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm426.cHALLOWEEN_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm426.cHALLOWEEN_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 427,
    "baseDexId": 427,
    "speciesName": "buneary",
    "forms": [
      {
        "formId": "buneary",
        "name": "buneary",
        "displayName": "Buneary",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/427.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/427.png",
        "isDefault": true
      },
      {
        "formId": "buneary-april-2020",
        "name": "buneary-april-2020",
        "displayName": "April 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm427.cAPRIL_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm427.cAPRIL_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 428,
    "baseDexId": 428,
    "speciesName": "lopunny",
    "forms": [
      {
        "formId": "lopunny",
        "name": "lopunny",
        "displayName": "Lopunny",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/428.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/428.png",
        "isDefault": true
      },
      {
        "formId": "lopunny-april-2020",
        "name": "lopunny-april-2020",
        "displayName": "April 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm428.cAPRIL_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm428.cAPRIL_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 440,
    "baseDexId": 440,
    "speciesName": "happiny",
    "forms": [
      {
        "formId": "happiny",
        "name": "happiny",
        "displayName": "Happiny",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/440.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/440.png",
        "isDefault": true
      },
      {
        "formId": "happiny-november-2018",
        "name": "happiny-november-2018",
        "displayName": "November 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm440.cNOVEMBER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm440.cNOVEMBER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 453,
    "baseDexId": 453,
    "speciesName": "croagunk",
    "forms": [
      {
        "formId": "croagunk",
        "name": "croagunk",
        "displayName": "Croagunk",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/453.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/453.png",
        "isDefault": true
      },
      {
        "formId": "croagunk-fall-2020",
        "name": "croagunk-fall-2020",
        "displayName": "Fall 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm453.cFALL_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm453.cFALL_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 454,
    "baseDexId": 454,
    "speciesName": "toxicroak",
    "forms": [
      {
        "formId": "toxicroak",
        "name": "toxicroak",
        "displayName": "Toxicroak",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/454.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/454.png",
        "isDefault": true
      },
      {
        "formId": "toxicroak-fall-2020",
        "name": "toxicroak-fall-2020",
        "displayName": "Fall 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm454.cFALL_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm454.cFALL_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 466,
    "baseDexId": 466,
    "speciesName": "electivire",
    "forms": [
      {
        "formId": "electivire",
        "name": "electivire",
        "displayName": "Electivire",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/466.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/466.png",
        "isDefault": true
      },
      {
        "formId": "electivire-spring-2023-instinct",
        "name": "electivire-spring-2023-instinct",
        "displayName": "Spring 2023 Instinct",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm466.cSPRING_2023_INSTINCT.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm466.cSPRING_2023_INSTINCT.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 468,
    "baseDexId": 468,
    "speciesName": "togekiss",
    "forms": [
      {
        "formId": "togekiss",
        "name": "togekiss",
        "displayName": "Togekiss",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/468.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/468.png",
        "isDefault": true
      },
      {
        "formId": "togekiss-april-2020",
        "name": "togekiss-april-2020",
        "displayName": "April 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm468.cAPRIL_2020_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm468.cAPRIL_2020_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 470,
    "baseDexId": 470,
    "speciesName": "leafeon",
    "forms": [
      {
        "formId": "leafeon",
        "name": "leafeon",
        "displayName": "Leafeon",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/470.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/470.png",
        "isDefault": true
      },
      {
        "formId": "leafeon-holiday-2022",
        "name": "leafeon-holiday-2022",
        "displayName": "Holiday 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm470.cHOLIDAY_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm470.cHOLIDAY_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "leafeon-may-2023",
        "name": "leafeon-may-2023",
        "displayName": "May 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm470.cMAY_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm470.cMAY_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "leafeon-november-2018",
        "name": "leafeon-november-2018",
        "displayName": "November 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm470.cNOVEMBER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm470.cNOVEMBER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "leafeon-spring-2023",
        "name": "leafeon-spring-2023",
        "displayName": "Spring 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm470.cSPRING_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm470.cSPRING_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 471,
    "baseDexId": 471,
    "speciesName": "glaceon",
    "forms": [
      {
        "formId": "glaceon",
        "name": "glaceon",
        "displayName": "Glaceon",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/471.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/471.png",
        "isDefault": true
      },
      {
        "formId": "glaceon-holiday-2021",
        "name": "glaceon-holiday-2021",
        "displayName": "Holiday 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm471.cHOLIDAY_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm471.cHOLIDAY_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "glaceon-holiday-2022",
        "name": "glaceon-holiday-2022",
        "displayName": "Holiday 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm471.cHOLIDAY_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm471.cHOLIDAY_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "glaceon-may-2023",
        "name": "glaceon-may-2023",
        "displayName": "May 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm471.cMAY_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm471.cMAY_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "glaceon-november-2018",
        "name": "glaceon-november-2018",
        "displayName": "November 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm471.cNOVEMBER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm471.cNOVEMBER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "glaceon-spring-2023",
        "name": "glaceon-spring-2023",
        "displayName": "Spring 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm471.cSPRING_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm471.cSPRING_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 477,
    "baseDexId": 477,
    "speciesName": "dusknoir",
    "forms": [
      {
        "formId": "dusknoir",
        "name": "dusknoir",
        "displayName": "Dusknoir",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/477.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/477.png",
        "isDefault": true
      },
      {
        "formId": "dusknoir-fall-2022",
        "name": "dusknoir-fall-2022",
        "displayName": "Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm477.cFALL_2022_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm477.cFALL_2022_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 479,
    "baseDexId": 479,
    "speciesName": "rotom",
    "forms": [
      {
        "formId": "rotom",
        "name": "rotom",
        "displayName": "Rotom",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/479.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/479.png",
        "isDefault": true
      },
      {
        "formId": "rotom-heat",
        "name": "rotom-heat",
        "displayName": "Heat",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10008.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10008.png",
        "isDefault": true
      },
      {
        "formId": "rotom-wash",
        "name": "rotom-wash",
        "displayName": "Wash",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10009.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10009.png",
        "isDefault": true
      },
      {
        "formId": "rotom-frost",
        "name": "rotom-frost",
        "displayName": "Frost",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10010.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10010.png",
        "isDefault": true
      },
      {
        "formId": "rotom-fan",
        "name": "rotom-fan",
        "displayName": "Fan",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10011.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10011.png",
        "isDefault": true
      },
      {
        "formId": "rotom-mow",
        "name": "rotom-mow",
        "displayName": "Mow",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10012.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10012.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 483,
    "baseDexId": 483,
    "speciesName": "dialga",
    "forms": [
      {
        "formId": "dialga",
        "name": "dialga",
        "displayName": "Dialga",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/483.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/483.png",
        "isDefault": true
      },
      {
        "formId": "dialga-origin",
        "name": "dialga-origin",
        "displayName": "Origin",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10245.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10245.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 484,
    "baseDexId": 484,
    "speciesName": "palkia",
    "forms": [
      {
        "formId": "palkia",
        "name": "palkia",
        "displayName": "Palkia",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/484.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/484.png",
        "isDefault": true
      },
      {
        "formId": "palkia-origin",
        "name": "palkia-origin",
        "displayName": "Origin",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10246.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10246.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 487,
    "baseDexId": 487,
    "speciesName": "giratina",
    "forms": [
      {
        "formId": "giratina-altered",
        "name": "giratina-altered",
        "displayName": "Altered",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/487.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/487.png",
        "isDefault": true
      },
      {
        "formId": "giratina-origin",
        "name": "giratina-origin",
        "displayName": "Origin",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10007.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10007.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 492,
    "baseDexId": 492,
    "speciesName": "shaymin",
    "forms": [
      {
        "formId": "shaymin-land",
        "name": "shaymin-land",
        "displayName": "Land",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/492.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/492.png",
        "isDefault": true
      },
      {
        "formId": "shaymin-sky",
        "name": "shaymin-sky",
        "displayName": "Sky",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10006.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10006.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 503,
    "baseDexId": 503,
    "speciesName": "samurott",
    "forms": [
      {
        "formId": "samurott",
        "name": "samurott",
        "displayName": "Samurott",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/503.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/503.png",
        "isDefault": true
      },
      {
        "formId": "samurott-hisui",
        "name": "samurott-hisui",
        "displayName": "Hisui",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10236.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10236.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 522,
    "baseDexId": 522,
    "speciesName": "blitzle",
    "forms": [
      {
        "formId": "blitzle",
        "name": "blitzle",
        "displayName": "Blitzle",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/522.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/522.png",
        "isDefault": true
      },
      {
        "formId": "blitzle-fashion-2021",
        "name": "blitzle-fashion-2021",
        "displayName": "Fashion 2021",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm522.cFASHION_2021_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm522.cFASHION_2021_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 546,
    "baseDexId": 546,
    "speciesName": "cottonee",
    "forms": [
      {
        "formId": "cottonee",
        "name": "cottonee",
        "displayName": "Cottonee",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/546.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/546.png",
        "isDefault": true
      },
      {
        "formId": "cottonee-spring-2024",
        "name": "cottonee-spring-2024",
        "displayName": "Spring 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm546.cSPRING_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm546.cSPRING_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 547,
    "baseDexId": 547,
    "speciesName": "whimsicott",
    "forms": [
      {
        "formId": "whimsicott",
        "name": "whimsicott",
        "displayName": "Whimsicott",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/547.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/547.png",
        "isDefault": true
      },
      {
        "formId": "whimsicott-spring-2024",
        "name": "whimsicott-spring-2024",
        "displayName": "Spring 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm547.cSPRING_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm547.cSPRING_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 549,
    "baseDexId": 549,
    "speciesName": "lilligant",
    "forms": [
      {
        "formId": "lilligant",
        "name": "lilligant",
        "displayName": "Lilligant",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/549.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/549.png",
        "isDefault": true
      },
      {
        "formId": "lilligant-hisui",
        "name": "lilligant-hisui",
        "displayName": "Hisui",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10237.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10237.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 550,
    "baseDexId": 550,
    "speciesName": "basculin",
    "forms": [
      {
        "formId": "basculin-red-striped",
        "name": "basculin-red-striped",
        "displayName": "Red Striped",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/550.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/550.png",
        "isDefault": true
      },
      {
        "formId": "basculin-blue-striped",
        "name": "basculin-blue-striped",
        "displayName": "Blue Striped",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10016.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10016.png",
        "isDefault": true
      },
      {
        "formId": "basculin-white-striped",
        "name": "basculin-white-striped",
        "displayName": "White Striped",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10247.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10247.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 554,
    "baseDexId": 554,
    "speciesName": "darumaka",
    "forms": [
      {
        "formId": "darumaka",
        "name": "darumaka",
        "displayName": "Darumaka",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/554.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/554.png",
        "isDefault": true
      },
      {
        "formId": "darumaka-galar",
        "name": "darumaka-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10176.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10176.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 555,
    "baseDexId": 555,
    "speciesName": "darmanitan",
    "forms": [
      {
        "formId": "darmanitan-standard",
        "name": "darmanitan-standard",
        "displayName": "Darmanitan",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/555.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/555.png",
        "isDefault": true
      },
      {
        "formId": "darmanitan-galar-standard",
        "name": "darmanitan-galar-standard",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10177.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10177.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 562,
    "baseDexId": 562,
    "speciesName": "yamask",
    "forms": [
      {
        "formId": "yamask",
        "name": "yamask",
        "displayName": "Yamask",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/562.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/562.png",
        "isDefault": true
      },
      {
        "formId": "yamask-galar",
        "name": "yamask-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10179.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10179.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 570,
    "baseDexId": 570,
    "speciesName": "zorua",
    "forms": [
      {
        "formId": "zorua",
        "name": "zorua",
        "displayName": "Zorua",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/570.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/570.png",
        "isDefault": true
      },
      {
        "formId": "zorua-hisui",
        "name": "zorua-hisui",
        "displayName": "Hisui",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10238.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10238.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 571,
    "baseDexId": 571,
    "speciesName": "zoroark",
    "forms": [
      {
        "formId": "zoroark",
        "name": "zoroark",
        "displayName": "Zoroark",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/571.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/571.png",
        "isDefault": true
      },
      {
        "formId": "zoroark-hisui",
        "name": "zoroark-hisui",
        "displayName": "Hisui",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10239.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10239.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 572,
    "baseDexId": 572,
    "speciesName": "minccino",
    "forms": [
      {
        "formId": "minccino",
        "name": "minccino",
        "displayName": "Minccino",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/572.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/572.png",
        "isDefault": true
      },
      {
        "formId": "minccino-fashion-2025",
        "name": "minccino-fashion-2025",
        "displayName": "Fashion 2025",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm572.cFASHION_2025.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm572.cFASHION_2025.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 573,
    "baseDexId": 573,
    "speciesName": "cinccino",
    "forms": [
      {
        "formId": "cinccino",
        "name": "cinccino",
        "displayName": "Cinccino",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/573.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/573.png",
        "isDefault": true
      },
      {
        "formId": "cinccino-fashion-2025",
        "name": "cinccino-fashion-2025",
        "displayName": "Fashion 2025",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm573.cFASHION_2025.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm573.cFASHION_2025.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 585,
    "baseDexId": 585,
    "speciesName": "deerling",
    "forms": [
      {
        "formId": "deerling-spring",
        "name": "deerling-spring",
        "displayName": "Spring",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/585.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/585.png",
        "isDefault": true
      },
      {
        "formId": "deerling-summer",
        "name": "deerling-summer",
        "displayName": "Summer",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm585.fSUMMER.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm585.fSUMMER.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "deerling-autumn",
        "name": "deerling-autumn",
        "displayName": "Autumn",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm585.fAUTUMN.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm585.fAUTUMN.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "deerling-winter",
        "name": "deerling-winter",
        "displayName": "Winter",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm585.fWINTER.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm585.fWINTER.s.icon.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 586,
    "baseDexId": 586,
    "speciesName": "sawsbuck",
    "forms": [
      {
        "formId": "sawsbuck-spring",
        "name": "sawsbuck-spring",
        "displayName": "Spring",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/586.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/586.png",
        "isDefault": true
      },
      {
        "formId": "sawsbuck-summer",
        "name": "sawsbuck-summer",
        "displayName": "Summer",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm586.fSUMMER.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm586.fSUMMER.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "sawsbuck-autumn",
        "name": "sawsbuck-autumn",
        "displayName": "Autumn",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm586.fAUTUMN.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm586.fAUTUMN.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "sawsbuck-winter",
        "name": "sawsbuck-winter",
        "displayName": "Winter",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm586.fWINTER.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm586.fWINTER.s.icon.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 592,
    "baseDexId": 592,
    "speciesName": "frillish",
    "forms": [
      {
        "formId": "frillish-male",
        "name": "frillish-male",
        "displayName": "Male",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/592.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/592.png",
        "isDefault": true
      },
      {
        "formId": "frillish-female",
        "name": "frillish-female",
        "displayName": "Female",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/female/592.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/female/592.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 593,
    "baseDexId": 593,
    "speciesName": "jellicent",
    "forms": [
      {
        "formId": "jellicent-male",
        "name": "jellicent-male",
        "displayName": "Male",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/593.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/593.png",
        "isDefault": true
      },
      {
        "formId": "jellicent-female",
        "name": "jellicent-female",
        "displayName": "Female",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/female/593.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/female/593.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 613,
    "baseDexId": 613,
    "speciesName": "cubchoo",
    "forms": [
      {
        "formId": "cubchoo",
        "name": "cubchoo",
        "displayName": "Cubchoo",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/613.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/613.png",
        "isDefault": true
      },
      {
        "formId": "cubchoo-winter-2020",
        "name": "cubchoo-winter-2020",
        "displayName": "Winter 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm613.fWINTER_2020.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm613.fWINTER_2020.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 614,
    "baseDexId": 614,
    "speciesName": "beartic",
    "forms": [
      {
        "formId": "beartic",
        "name": "beartic",
        "displayName": "Beartic",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/614.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/614.png",
        "isDefault": true
      },
      {
        "formId": "beartic-winter-2020",
        "name": "beartic-winter-2020",
        "displayName": "Winter 2020",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm614.fWINTER_2020.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm614.fWINTER_2020.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 618,
    "baseDexId": 618,
    "speciesName": "stunfisk",
    "forms": [
      {
        "formId": "stunfisk",
        "name": "stunfisk",
        "displayName": "Stunfisk",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/618.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/618.png",
        "isDefault": true
      },
      {
        "formId": "stunfisk-galar",
        "name": "stunfisk-galar",
        "displayName": "Galar",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10180.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10180.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 628,
    "baseDexId": 628,
    "speciesName": "braviary",
    "forms": [
      {
        "formId": "braviary",
        "name": "braviary",
        "displayName": "Braviary",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/628.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/628.png",
        "isDefault": true
      },
      {
        "formId": "braviary-hisui",
        "name": "braviary-hisui",
        "displayName": "Hisui",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10240.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10240.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 641,
    "baseDexId": 641,
    "speciesName": "tornadus",
    "forms": [
      {
        "formId": "tornadus-incarnate",
        "name": "tornadus-incarnate",
        "displayName": "Incarnate",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/641.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/641.png",
        "isDefault": true
      },
      {
        "formId": "tornadus-therian",
        "name": "tornadus-therian",
        "displayName": "Therian",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10019.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10019.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 642,
    "baseDexId": 642,
    "speciesName": "thundurus",
    "forms": [
      {
        "formId": "thundurus-incarnate",
        "name": "thundurus-incarnate",
        "displayName": "Incarnate",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/642.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/642.png",
        "isDefault": true
      },
      {
        "formId": "thundurus-therian",
        "name": "thundurus-therian",
        "displayName": "Therian",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10020.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10020.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 645,
    "baseDexId": 645,
    "speciesName": "landorus",
    "forms": [
      {
        "formId": "landorus-incarnate",
        "name": "landorus-incarnate",
        "displayName": "Incarnate",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/645.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/645.png",
        "isDefault": true
      },
      {
        "formId": "landorus-therian",
        "name": "landorus-therian",
        "displayName": "Therian",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10021.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10021.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 646,
    "baseDexId": 646,
    "speciesName": "kyurem",
    "forms": [
      {
        "formId": "kyurem",
        "name": "kyurem",
        "displayName": "Kyurem",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/646.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/646.png",
        "isDefault": true
      },
      {
        "formId": "kyurem-black",
        "name": "kyurem-black",
        "displayName": "Black",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10022.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10022.png",
        "isDefault": true
      },
      {
        "formId": "kyurem-white",
        "name": "kyurem-white",
        "displayName": "White",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10023.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10023.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 647,
    "baseDexId": 647,
    "speciesName": "keldeo",
    "forms": [
      {
        "formId": "keldeo-ordinary",
        "name": "keldeo-ordinary",
        "displayName": "Keldeo",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/647.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/647.png",
        "isDefault": true
      },
      {
        "formId": "keldeo-resolute",
        "name": "keldeo-resolute",
        "displayName": "Resolute",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10024.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10024.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 649,
    "baseDexId": 649,
    "speciesName": "genesect",
    "forms": [
      {
        "formId": "genesect",
        "name": "genesect",
        "displayName": "Genesect",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/649.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/649.png",
        "isDefault": true
      },
      {
        "formId": "genesect-douse",
        "name": "genesect-douse",
        "displayName": "Douse",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm649.fDOUSE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm649.fDOUSE.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "genesect-shock",
        "name": "genesect-shock",
        "displayName": "Shock",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm649.fSHOCK.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm649.fSHOCK.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "genesect-burn",
        "name": "genesect-burn",
        "displayName": "Burn",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm649.fBURN.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm649.fBURN.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "genesect-chill",
        "name": "genesect-chill",
        "displayName": "Chill",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm649.fCHILL.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm649.fCHILL.s.icon.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 656,
    "baseDexId": 656,
    "speciesName": "froakie",
    "forms": [
      {
        "formId": "froakie",
        "name": "froakie",
        "displayName": "Froakie",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/656.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/656.png",
        "isDefault": true
      },
      {
        "formId": "froakie-fall-2024",
        "name": "froakie-fall-2024",
        "displayName": "Fall 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm656.cFALL_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm656.cFALL_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 657,
    "baseDexId": 657,
    "speciesName": "frogadier",
    "forms": [
      {
        "formId": "frogadier",
        "name": "frogadier",
        "displayName": "Frogadier",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/657.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/657.png",
        "isDefault": true
      },
      {
        "formId": "frogadier-fall-2024",
        "name": "frogadier-fall-2024",
        "displayName": "Fall 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm657.cFALL_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm657.cFALL_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 658,
    "baseDexId": 658,
    "speciesName": "greninja",
    "forms": [
      {
        "formId": "greninja",
        "name": "greninja",
        "displayName": "Greninja",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/658.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/658.png",
        "isDefault": true
      },
      {
        "formId": "greninja-fall-2024",
        "name": "greninja-fall-2024",
        "displayName": "Fall 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm658.cFALL_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm658.cFALL_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 666,
    "baseDexId": 666,
    "speciesName": "vivillon",
    "forms": [
      {
        "formId": "vivillon-archipelago",
        "name": "vivillon-archipelago",
        "displayName": "Archipelago",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fARCHIPELAGO.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fARCHIPELAGO.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-continental",
        "name": "vivillon-continental",
        "displayName": "Continental",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fCONTINENTAL.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fCONTINENTAL.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-elegant",
        "name": "vivillon-elegant",
        "displayName": "Elegant",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fELEGANT.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fELEGANT.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-garden",
        "name": "vivillon-garden",
        "displayName": "Garden",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fGARDEN.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fGARDEN.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-high-plains",
        "name": "vivillon-high-plains",
        "displayName": "High Plains",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fHIGH_PLAINS.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fHIGH_PLAINS.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-icy-snow",
        "name": "vivillon-icy-snow",
        "displayName": "Icy Snow",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fICY_SNOW.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fICY_SNOW.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-jungle",
        "name": "vivillon-jungle",
        "displayName": "Jungle",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fJUNGLE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fJUNGLE.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-marine",
        "name": "vivillon-marine",
        "displayName": "Marine",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fMARINE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fMARINE.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-meadow",
        "name": "vivillon-meadow",
        "displayName": "Meadow",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/666.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/666.png",
        "isDefault": true
      },
      {
        "formId": "vivillon-modern",
        "name": "vivillon-modern",
        "displayName": "Modern",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fMODERN.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fMODERN.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-monsoon",
        "name": "vivillon-monsoon",
        "displayName": "Monsoon",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fMONSOON.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fMONSOON.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-ocean",
        "name": "vivillon-ocean",
        "displayName": "Ocean",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fOCEAN.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fOCEAN.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-polar",
        "name": "vivillon-polar",
        "displayName": "Polar",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fPOLAR.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fPOLAR.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-river",
        "name": "vivillon-river",
        "displayName": "River",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fRIVER.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fRIVER.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-sandstorm",
        "name": "vivillon-sandstorm",
        "displayName": "Sandstorm",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fSANDSTORM.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fSANDSTORM.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-savanna",
        "name": "vivillon-savanna",
        "displayName": "Savanna",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fSAVANNA.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fSAVANNA.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-sun",
        "name": "vivillon-sun",
        "displayName": "Sun",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fSUN.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fSUN.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-tundra",
        "name": "vivillon-tundra",
        "displayName": "Tundra",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fTUNDRA.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fTUNDRA.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-fancy",
        "name": "vivillon-fancy",
        "displayName": "Fancy",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fFANCY.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fFANCY.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "vivillon-poke-ball",
        "name": "vivillon-poke-ball",
        "displayName": "Poke Ball",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fPOKEBALL.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm666.fPOKEBALL.s.icon.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 668,
    "baseDexId": 668,
    "speciesName": "pyroar",
    "forms": [
      {
        "formId": "pyroar-male",
        "name": "pyroar-male",
        "displayName": "Male",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/668.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/668.png",
        "isDefault": true
      },
      {
        "formId": "pyroar-female",
        "name": "pyroar-female",
        "displayName": "Female",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/female/668.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/female/668.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 669,
    "baseDexId": 669,
    "speciesName": "flabebe",
    "forms": [
      {
        "formId": "flabebe-red",
        "name": "flabebe-red",
        "displayName": "Red",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm669.fRED.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm669.fRED.s.icon.png",
        "isDefault": true
      },
      {
        "formId": "flabebe-yellow",
        "name": "flabebe-yellow",
        "displayName": "Yellow",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm669.fYELLOW.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm669.fYELLOW.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "flabebe-orange",
        "name": "flabebe-orange",
        "displayName": "Orange",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm669.fORANGE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm669.fORANGE.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "flabebe-blue",
        "name": "flabebe-blue",
        "displayName": "Blue",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm669.fBLUE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm669.fBLUE.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "flabebe-white",
        "name": "flabebe-white",
        "displayName": "White",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm669.fWHITE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm669.fWHITE.s.icon.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 670,
    "baseDexId": 670,
    "speciesName": "floette",
    "forms": [
      {
        "formId": "floette-red",
        "name": "floette-red",
        "displayName": "Red",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm670.fRED.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm670.fRED.s.icon.png",
        "isDefault": true
      },
      {
        "formId": "floette-yellow",
        "name": "floette-yellow",
        "displayName": "Yellow",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm670.fYELLOW.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm670.fYELLOW.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "floette-orange",
        "name": "floette-orange",
        "displayName": "Orange",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm670.fORANGE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm670.fORANGE.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "floette-blue",
        "name": "floette-blue",
        "displayName": "Blue",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm670.fBLUE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm670.fBLUE.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "floette-white",
        "name": "floette-white",
        "displayName": "White",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm670.fWHITE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm670.fWHITE.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "floette-eternal",
        "name": "floette-eternal",
        "displayName": "Eternal",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10061.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10061.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 671,
    "baseDexId": 671,
    "speciesName": "florges",
    "forms": [
      {
        "formId": "florges-red",
        "name": "florges-red",
        "displayName": "Red",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm671.fRED.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm671.fRED.s.icon.png",
        "isDefault": true
      },
      {
        "formId": "florges-yellow",
        "name": "florges-yellow",
        "displayName": "Yellow",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm671.fYELLOW.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm671.fYELLOW.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "florges-orange",
        "name": "florges-orange",
        "displayName": "Orange",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm671.fORANGE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm671.fORANGE.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "florges-blue",
        "name": "florges-blue",
        "displayName": "Blue",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm671.fBLUE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm671.fBLUE.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "florges-white",
        "name": "florges-white",
        "displayName": "White",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm671.fWHITE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm671.fWHITE.s.icon.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 676,
    "baseDexId": 676,
    "speciesName": "furfrou",
    "forms": [
      {
        "formId": "furfrou-natural",
        "name": "furfrou-natural",
        "displayName": "Natural",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/676.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/676.png",
        "isDefault": true
      },
      {
        "formId": "furfrou-heart",
        "name": "furfrou-heart",
        "displayName": "Heart",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fHEART.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fHEART.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "furfrou-star",
        "name": "furfrou-star",
        "displayName": "Star",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fSTAR.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fSTAR.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "furfrou-diamond",
        "name": "furfrou-diamond",
        "displayName": "Diamond",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fDIAMOND.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fDIAMOND.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "furfrou-debutante",
        "name": "furfrou-debutante",
        "displayName": "Debutante",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fDEBUTANTE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fDEBUTANTE.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "furfrou-matron",
        "name": "furfrou-matron",
        "displayName": "Matron",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fMATRON.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fMATRON.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "furfrou-dandy",
        "name": "furfrou-dandy",
        "displayName": "Dandy",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fDANDY.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fDANDY.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "furfrou-la-reine",
        "name": "furfrou-la-reine",
        "displayName": "La Reine",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fLA_REINE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fLA_REINE.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "furfrou-kabuki",
        "name": "furfrou-kabuki",
        "displayName": "Kabuki",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fKABUKI.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fKABUKI.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "furfrou-pharaoh",
        "name": "furfrou-pharaoh",
        "displayName": "Pharaoh",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fPHARAOH.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm676.fPHARAOH.s.icon.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 678,
    "baseDexId": 678,
    "speciesName": "meowstic",
    "forms": [
      {
        "formId": "meowstic-male",
        "name": "meowstic-male",
        "displayName": "Male",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/678.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/678.png",
        "isDefault": true
      },
      {
        "formId": "meowstic-female",
        "name": "meowstic-female",
        "displayName": "Female",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10025.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10025.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 700,
    "baseDexId": 700,
    "speciesName": "sylveon",
    "forms": [
      {
        "formId": "sylveon",
        "name": "sylveon",
        "displayName": "Sylveon",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/700.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/700.png",
        "isDefault": true
      },
      {
        "formId": "sylveon-holiday-2022",
        "name": "sylveon-holiday-2022",
        "displayName": "Holiday 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm700.cHOLIDAY_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm700.cHOLIDAY_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "sylveon-may-2023",
        "name": "sylveon-may-2023",
        "displayName": "May 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm700.cMAY_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm700.cMAY_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "sylveon-november-2018",
        "name": "sylveon-november-2018",
        "displayName": "November 2018",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm700.cNOVEMBER_2018.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm700.cNOVEMBER_2018.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "sylveon-spring-2023",
        "name": "sylveon-spring-2023",
        "displayName": "Spring 2023",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm700.cSPRING_2023.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm700.cSPRING_2023.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 702,
    "baseDexId": 702,
    "speciesName": "dedenne",
    "forms": [
      {
        "formId": "dedenne",
        "name": "dedenne",
        "displayName": "Dedenne",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/702.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/702.png",
        "isDefault": true
      },
      {
        "formId": "dedenne-winter-2024",
        "name": "dedenne-winter-2024",
        "displayName": "Winter 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm702.cWINTER_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm702.cWINTER_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 710,
    "baseDexId": 710,
    "speciesName": "pumpkaboo",
    "forms": [
      {
        "formId": "pumpkaboo-average",
        "name": "pumpkaboo-average",
        "displayName": "Average",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/710.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/710.png",
        "isDefault": true
      },
      {
        "formId": "pumpkaboo-small",
        "name": "pumpkaboo-small",
        "displayName": "Small",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10027.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10027.png",
        "isDefault": true
      },
      {
        "formId": "pumpkaboo-large",
        "name": "pumpkaboo-large",
        "displayName": "Large",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10028.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10028.png",
        "isDefault": true
      },
      {
        "formId": "pumpkaboo-super",
        "name": "pumpkaboo-super",
        "displayName": "Super",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10029.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10029.png",
        "isDefault": true
      },
      {
        "formId": "pumpkaboo-average-fall-2022",
        "name": "pumpkaboo-average-fall-2022",
        "displayName": "Average Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm710.fAVERAGE.cFALL_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm710.fAVERAGE.cFALL_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pumpkaboo-large-fall-2022",
        "name": "pumpkaboo-large-fall-2022",
        "displayName": "Large Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm710.fLARGE.cFALL_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm710.fLARGE.cFALL_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pumpkaboo-small-fall-2022",
        "name": "pumpkaboo-small-fall-2022",
        "displayName": "Small Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm710.fSMALL.cFALL_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm710.fSMALL.cFALL_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "pumpkaboo-super-fall-2022",
        "name": "pumpkaboo-super-fall-2022",
        "displayName": "Super Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm710.fSUPER.cFALL_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm710.fSUPER.cFALL_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 711,
    "baseDexId": 711,
    "speciesName": "gourgeist",
    "forms": [
      {
        "formId": "gourgeist-average",
        "name": "gourgeist-average",
        "displayName": "Average",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/711.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/711.png",
        "isDefault": true
      },
      {
        "formId": "gourgeist-small",
        "name": "gourgeist-small",
        "displayName": "Small",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10030.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10030.png",
        "isDefault": true
      },
      {
        "formId": "gourgeist-large",
        "name": "gourgeist-large",
        "displayName": "Large",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10031.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10031.png",
        "isDefault": true
      },
      {
        "formId": "gourgeist-super",
        "name": "gourgeist-super",
        "displayName": "Super",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10032.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10032.png",
        "isDefault": true
      },
      {
        "formId": "gourgeist-average-fall-2022",
        "name": "gourgeist-average-fall-2022",
        "displayName": "Average Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm711.fAVERAGE.cFALL_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm711.fAVERAGE.cFALL_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "gourgeist-large-fall-2022",
        "name": "gourgeist-large-fall-2022",
        "displayName": "Large Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm711.fLARGE.cFALL_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm711.fLARGE.cFALL_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "gourgeist-small-fall-2022",
        "name": "gourgeist-small-fall-2022",
        "displayName": "Small Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm711.fSMALL.cFALL_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm711.fSMALL.cFALL_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "gourgeist-super-fall-2022",
        "name": "gourgeist-super-fall-2022",
        "displayName": "Super Fall 2022",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm711.fSUPER.cFALL_2022.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm711.fSUPER.cFALL_2022.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 713,
    "baseDexId": 713,
    "speciesName": "avalugg",
    "forms": [
      {
        "formId": "avalugg",
        "name": "avalugg",
        "displayName": "Avalugg",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/713.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/713.png",
        "isDefault": true
      },
      {
        "formId": "avalugg-hisui",
        "name": "avalugg-hisui",
        "displayName": "Hisui",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10243.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10243.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 714,
    "baseDexId": 714,
    "speciesName": "noibat",
    "forms": [
      {
        "formId": "noibat",
        "name": "noibat",
        "displayName": "Noibat",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/714.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/714.png",
        "isDefault": true
      },
      {
        "formId": "noibat-halloween-2025",
        "name": "noibat-halloween-2025",
        "displayName": "Halloween 2025",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm714.cHALLOWEEN_2025.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm714.cHALLOWEEN_2025.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 715,
    "baseDexId": 715,
    "speciesName": "noivern",
    "forms": [
      {
        "formId": "noivern",
        "name": "noivern",
        "displayName": "Noivern",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/715.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/715.png",
        "isDefault": true
      },
      {
        "formId": "noivern-halloween-2025",
        "name": "noivern-halloween-2025",
        "displayName": "Halloween 2025",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm715.cHALLOWEEN_2025.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm715.cHALLOWEEN_2025.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 718,
    "baseDexId": 718,
    "speciesName": "zygarde",
    "forms": [
      {
        "formId": "zygarde-50",
        "name": "zygarde-50",
        "displayName": "50",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/718.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/718.png",
        "isDefault": true
      },
      {
        "formId": "zygarde-10-power-construct",
        "name": "zygarde-10-power-construct",
        "displayName": "10 Power Construct",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10118.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10118.png",
        "isDefault": true
      },
      {
        "formId": "zygarde-50-power-construct",
        "name": "zygarde-50-power-construct",
        "displayName": "50 Power Construct",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10119.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10119.png",
        "isDefault": true
      },
      {
        "formId": "zygarde-complete",
        "name": "zygarde-complete",
        "displayName": "Complete",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10120.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10120.png",
        "isDefault": true
      },
      {
        "formId": "zygarde-10",
        "name": "zygarde-10",
        "displayName": "10",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10181.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10181.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 720,
    "baseDexId": 720,
    "speciesName": "hoopa",
    "forms": [
      {
        "formId": "hoopa",
        "name": "hoopa",
        "displayName": "Confined",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/720.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/720.png",
        "isDefault": true
      },
      {
        "formId": "hoopa-unbound",
        "name": "hoopa-unbound",
        "displayName": "Unbound",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10086.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10086.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 722,
    "baseDexId": 722,
    "speciesName": "rowlet",
    "forms": [
      {
        "formId": "rowlet",
        "name": "rowlet",
        "displayName": "Rowlet",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/722.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/722.png",
        "isDefault": true
      },
      {
        "formId": "rowlet-fall-2024",
        "name": "rowlet-fall-2024",
        "displayName": "Fall 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm722.cFALL_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm722.cFALL_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 723,
    "baseDexId": 723,
    "speciesName": "dartrix",
    "forms": [
      {
        "formId": "dartrix",
        "name": "dartrix",
        "displayName": "Dartrix",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/723.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/723.png",
        "isDefault": true
      },
      {
        "formId": "dartrix-fall-2024",
        "name": "dartrix-fall-2024",
        "displayName": "Fall 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm723.cFALL_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm723.cFALL_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 724,
    "baseDexId": 724,
    "speciesName": "decidueye",
    "forms": [
      {
        "formId": "decidueye",
        "name": "decidueye",
        "displayName": "Decidueye",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/724.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/724.png",
        "isDefault": true
      },
      {
        "formId": "decidueye-hisui",
        "name": "decidueye-hisui",
        "displayName": "Hisui",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10244.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10244.png",
        "isDefault": true
      },
      {
        "formId": "decidueye-fall-2024",
        "name": "decidueye-fall-2024",
        "displayName": "Fall 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm724.cFALL_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm724.cFALL_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 737,
    "baseDexId": 737,
    "speciesName": "charjabug",
    "forms": [
      {
        "formId": "charjabug",
        "name": "charjabug",
        "displayName": "Charjabug",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/737.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/737.png",
        "isDefault": true
      },
      {
        "formId": "charjabug-winter-2025",
        "name": "charjabug-winter-2025",
        "displayName": "Winter 2025",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm737.fWINTER_2025.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm737.fWINTER_2025.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 738,
    "baseDexId": 738,
    "speciesName": "vikavolt",
    "forms": [
      {
        "formId": "vikavolt",
        "name": "vikavolt",
        "displayName": "Vikavolt",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/738.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/738.png",
        "isDefault": true
      },
      {
        "formId": "vikavolt-winter-2025",
        "name": "vikavolt-winter-2025",
        "displayName": "Winter 2025",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm738.fWINTER_2025.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm738.fWINTER_2025.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 741,
    "baseDexId": 741,
    "speciesName": "oricorio",
    "forms": [
      {
        "formId": "oricorio-baile",
        "name": "oricorio-baile",
        "displayName": "Baile",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/741.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/741.png",
        "isDefault": true
      },
      {
        "formId": "oricorio-pom-pom",
        "name": "oricorio-pom-pom",
        "displayName": "Pom Pom",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10123.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10123.png",
        "isDefault": true
      },
      {
        "formId": "oricorio-pau",
        "name": "oricorio-pau",
        "displayName": "Pau",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10124.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10124.png",
        "isDefault": true
      },
      {
        "formId": "oricorio-sensu",
        "name": "oricorio-sensu",
        "displayName": "Sensu",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10125.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10125.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 745,
    "baseDexId": 745,
    "speciesName": "lycanroc",
    "forms": [
      {
        "formId": "lycanroc-midday",
        "name": "lycanroc-midday",
        "displayName": "Midday",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/745.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/745.png",
        "isDefault": true
      },
      {
        "formId": "lycanroc-midnight",
        "name": "lycanroc-midnight",
        "displayName": "Midnight",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10126.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10126.png",
        "isDefault": true
      },
      {
        "formId": "lycanroc-dusk",
        "name": "lycanroc-dusk",
        "displayName": "Dusk",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10152.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10152.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 760,
    "baseDexId": 760,
    "speciesName": "bewear",
    "forms": [
      {
        "formId": "bewear",
        "name": "bewear",
        "displayName": "Bewear",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/760.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/760.png",
        "isDefault": true
      },
      {
        "formId": "bewear-wildarea-2025",
        "name": "bewear-wildarea-2025",
        "displayName": "Wildarea 2025",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm760.fWILDAREA_2025.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm760.fWILDAREA_2025.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 774,
    "baseDexId": 774,
    "speciesName": "minior",
    "forms": [
      {
        "formId": "minior-red",
        "name": "minior-red",
        "displayName": "Red",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10136.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10136.png",
        "isDefault": true
      },
      {
        "formId": "minior-orange",
        "name": "minior-orange",
        "displayName": "Orange",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10137.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10137.png",
        "isDefault": true
      },
      {
        "formId": "minior-yellow",
        "name": "minior-yellow",
        "displayName": "Yellow",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10138.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10138.png",
        "isDefault": true
      },
      {
        "formId": "minior-green",
        "name": "minior-green",
        "displayName": "Green",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10139.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10139.png",
        "isDefault": true
      },
      {
        "formId": "minior-blue",
        "name": "minior-blue",
        "displayName": "Blue",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10140.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10140.png",
        "isDefault": true
      },
      {
        "formId": "minior-indigo",
        "name": "minior-indigo",
        "displayName": "Indigo",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10141.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10141.png",
        "isDefault": true
      },
      {
        "formId": "minior-violet",
        "name": "minior-violet",
        "displayName": "Violet",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10142.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10142.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 800,
    "baseDexId": 800,
    "speciesName": "necrozma",
    "forms": [
      {
        "formId": "necrozma",
        "name": "necrozma",
        "displayName": "Necrozma",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/800.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/800.png",
        "isDefault": true
      },
      {
        "formId": "necrozma-dusk",
        "name": "necrozma-dusk",
        "displayName": "Dusk",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10155.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10155.png",
        "isDefault": true
      },
      {
        "formId": "necrozma-dawn",
        "name": "necrozma-dawn",
        "displayName": "Dawn",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10156.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10156.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 801,
    "baseDexId": 801,
    "speciesName": "magearna",
    "forms": [
      {
        "formId": "magearna",
        "name": "magearna",
        "displayName": "Magearna",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/801.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/801.png",
        "isDefault": true
      },
      {
        "formId": "magearna-original",
        "name": "magearna-original",
        "displayName": "Original",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10147.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10147.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 831,
    "baseDexId": 831,
    "speciesName": "wooloo",
    "forms": [
      {
        "formId": "wooloo",
        "name": "wooloo",
        "displayName": "Wooloo",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/831.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/831.png",
        "isDefault": true
      },
      {
        "formId": "wooloo-winter-2024",
        "name": "wooloo-winter-2024",
        "displayName": "Winter 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm831.cWINTER_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm831.cWINTER_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 832,
    "baseDexId": 832,
    "speciesName": "dubwool",
    "forms": [
      {
        "formId": "dubwool",
        "name": "dubwool",
        "displayName": "Dubwool",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/832.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/832.png",
        "isDefault": true
      },
      {
        "formId": "dubwool-winter-2024",
        "name": "dubwool-winter-2024",
        "displayName": "Winter 2024",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm832.cWINTER_2024.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm832.cWINTER_2024.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 849,
    "baseDexId": 849,
    "speciesName": "toxtricity",
    "forms": [
      {
        "formId": "toxtricity-amped",
        "name": "toxtricity-amped",
        "displayName": "Amped",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/849.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/849.png",
        "isDefault": true
      },
      {
        "formId": "toxtricity-low-key",
        "name": "toxtricity-low-key",
        "displayName": "Low Key",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10184.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10184.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 854,
    "baseDexId": 854,
    "speciesName": "sinistea",
    "forms": [
      {
        "formId": "sinistea-phony",
        "name": "sinistea-phony",
        "displayName": "Phony",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/854.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/854.png",
        "isDefault": true
      },
      {
        "formId": "sinistea-antique",
        "name": "sinistea-antique",
        "displayName": "Antique",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm854.fANTIQUE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm854.fANTIQUE.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "sinistea-phony-halloween-2026",
        "name": "sinistea-phony-halloween-2026",
        "displayName": "Halloween 2026 (Phony)",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm854.fP_HALLOWEEN_2026_01.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm854.fP_HALLOWEEN_2026_01.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "sinistea-antique-halloween-2026",
        "name": "sinistea-antique-halloween-2026",
        "displayName": "Halloween 2026 (Antique)",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm854.fA_HALLOWEEN_2026_01.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm854.fA_HALLOWEEN_2026_01.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 855,
    "baseDexId": 855,
    "speciesName": "polteageist",
    "forms": [
      {
        "formId": "polteageist-phony",
        "name": "polteageist-phony",
        "displayName": "Phony",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/855.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/855.png",
        "isDefault": true
      },
      {
        "formId": "polteageist-antique",
        "name": "polteageist-antique",
        "displayName": "Antique",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm855.fANTIQUE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm855.fANTIQUE.s.icon.png",
        "isDefault": false
      },
      {
        "formId": "polteageist-phony-halloween-2026",
        "name": "polteageist-phony-halloween-2026",
        "displayName": "Halloween 2026 (Phony)",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm855.fP_HALLOWEEN_2026_01.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm855.fP_HALLOWEEN_2026_01.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      },
      {
        "formId": "polteageist-antique-halloween-2026",
        "name": "polteageist-antique-halloween-2026",
        "displayName": "Halloween 2026 (Antique)",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm855.fA_HALLOWEEN_2026_01.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm855.fA_HALLOWEEN_2026_01.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 876,
    "baseDexId": 876,
    "speciesName": "indeedee",
    "forms": [
      {
        "formId": "indeedee-male",
        "name": "indeedee-male",
        "displayName": "Male",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/876.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/876.png",
        "isDefault": true
      },
      {
        "formId": "indeedee-female",
        "name": "indeedee-female",
        "displayName": "Female",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10186.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10186.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 888,
    "baseDexId": 888,
    "speciesName": "zacian",
    "forms": [
      {
        "formId": "zacian",
        "name": "zacian",
        "displayName": "Zacian",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/888.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/888.png",
        "isDefault": true
      },
      {
        "formId": "zacian-crowned",
        "name": "zacian-crowned",
        "displayName": "Crowned",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10188.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10188.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 889,
    "baseDexId": 889,
    "speciesName": "zamazenta",
    "forms": [
      {
        "formId": "zamazenta",
        "name": "zamazenta",
        "displayName": "Zamazenta",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/889.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/889.png",
        "isDefault": true
      },
      {
        "formId": "zamazenta-crowned",
        "name": "zamazenta-crowned",
        "displayName": "Crowned",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10189.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10189.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 892,
    "baseDexId": 892,
    "speciesName": "urshifu",
    "forms": [
      {
        "formId": "urshifu-single-strike",
        "name": "urshifu-single-strike",
        "displayName": "Single Strike",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/892.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/892.png",
        "isDefault": true
      },
      {
        "formId": "urshifu-rapid-strike",
        "name": "urshifu-rapid-strike",
        "displayName": "Rapid Strike",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10191.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10191.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 898,
    "baseDexId": 898,
    "speciesName": "calyrex",
    "forms": [
      {
        "formId": "calyrex",
        "name": "calyrex",
        "displayName": "Calyrex",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/898.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/898.png",
        "isDefault": true
      },
      {
        "formId": "calyrex-ice",
        "name": "calyrex-ice",
        "displayName": "Ice",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10193.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10193.png",
        "isDefault": true
      },
      {
        "formId": "calyrex-shadow",
        "name": "calyrex-shadow",
        "displayName": "Shadow",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10194.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10194.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 901,
    "baseDexId": 901,
    "speciesName": "ursaluna",
    "forms": [
      {
        "formId": "ursaluna",
        "name": "ursaluna",
        "displayName": "Ursaluna",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/901.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/901.png",
        "isDefault": true
      },
      {
        "formId": "ursaluna-halloween-2025",
        "name": "ursaluna-halloween-2025",
        "displayName": "Halloween 2025",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm901.cHALLOWEEN_2025.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm901.cHALLOWEEN_2025.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 905,
    "baseDexId": 905,
    "speciesName": "enamorus",
    "forms": [
      {
        "formId": "enamorus-incarnate",
        "name": "enamorus-incarnate",
        "displayName": "Incarnate",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/905.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/905.png",
        "isDefault": true
      },
      {
        "formId": "enamorus-therian",
        "name": "enamorus-therian",
        "displayName": "Therian",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10249.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10249.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 907,
    "baseDexId": 907,
    "speciesName": "floragato",
    "forms": [
      {
        "formId": "floragato",
        "name": "floragato",
        "displayName": "Floragato",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/907.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/907.png",
        "isDefault": true
      },
      {
        "formId": "floragato-horizons-2025",
        "name": "floragato-horizons-2025",
        "displayName": "Horizons 2025",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm907.cHORIZONS_2025_NOEVOLVE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm907.cHORIZONS_2025_NOEVOLVE.s.icon.png",
        "isDefault": false,
        "kind": "costume"
      }
    ]
  },
  {
    "speciesId": 916,
    "baseDexId": 916,
    "speciesName": "oinkologne",
    "forms": [
      {
        "formId": "oinkologne-male",
        "name": "oinkologne-male",
        "displayName": "Male",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/916.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/916.png",
        "isDefault": true
      },
      {
        "formId": "oinkologne-female",
        "name": "oinkologne-female",
        "displayName": "Female",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10254.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10254.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 925,
    "baseDexId": 925,
    "speciesName": "maushold",
    "forms": [
      {
        "formId": "maushold-family-of-four",
        "name": "maushold-family-of-four",
        "displayName": "Family Of Four",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/925.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/925.png",
        "isDefault": true
      },
      {
        "formId": "maushold-family-of-three",
        "name": "maushold-family-of-three",
        "displayName": "Family Of Three",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10257.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10257.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 931,
    "baseDexId": 931,
    "speciesName": "squawkabilly",
    "forms": [
      {
        "formId": "squawkabilly-green-plumage",
        "name": "squawkabilly-green-plumage",
        "displayName": "Green Plumage",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/931.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/931.png",
        "isDefault": true
      },
      {
        "formId": "squawkabilly-blue-plumage",
        "name": "squawkabilly-blue-plumage",
        "displayName": "Blue Plumage",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10260.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10260.png",
        "isDefault": true
      },
      {
        "formId": "squawkabilly-yellow-plumage",
        "name": "squawkabilly-yellow-plumage",
        "displayName": "Yellow Plumage",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10261.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10261.png",
        "isDefault": true
      },
      {
        "formId": "squawkabilly-white-plumage",
        "name": "squawkabilly-white-plumage",
        "displayName": "White Plumage",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10262.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10262.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 978,
    "baseDexId": 978,
    "speciesName": "tatsugiri",
    "forms": [
      {
        "formId": "tatsugiri-curly",
        "name": "tatsugiri-curly",
        "displayName": "Curly",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/978.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/978.png",
        "isDefault": true
      },
      {
        "formId": "tatsugiri-droopy",
        "name": "tatsugiri-droopy",
        "displayName": "Droopy",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10258.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10258.png",
        "isDefault": true
      },
      {
        "formId": "tatsugiri-stretchy",
        "name": "tatsugiri-stretchy",
        "displayName": "Stretchy",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10259.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10259.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 982,
    "baseDexId": 982,
    "speciesName": "dudunsparce",
    "forms": [
      {
        "formId": "dudunsparce-two-segment",
        "name": "dudunsparce-two-segment",
        "displayName": "Two Segment",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/982.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/982.png",
        "isDefault": true
      },
      {
        "formId": "dudunsparce-three-segment",
        "name": "dudunsparce-three-segment",
        "displayName": "Three Segment",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10255.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10255.png",
        "isDefault": true
      }
    ]
  },
  {
    "speciesId": 1012,
    "baseDexId": 1012,
    "speciesName": "poltchageist",
    "forms": [
      {
        "formId": "poltchageist-counterfeit",
        "name": "poltchageist-counterfeit",
        "displayName": "Counterfeit",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/1012.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/1012.png",
        "isDefault": true
      },
      {
        "formId": "poltchageist-artisan",
        "name": "poltchageist-artisan",
        "displayName": "Artisan",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm1012.fARTISAN.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm1012.fARTISAN.s.icon.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 1013,
    "baseDexId": 1013,
    "speciesName": "sinistcha",
    "forms": [
      {
        "formId": "sinistcha-unremarkable",
        "name": "sinistcha-unremarkable",
        "displayName": "Unremarkable",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/1013.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/1013.png",
        "isDefault": true
      },
      {
        "formId": "sinistcha-masterpiece",
        "name": "sinistcha-masterpiece",
        "displayName": "Masterpiece",
        "spritePath": "https://sprites.nexusdex.ai/pokeminers/pm1013.fMASTERPIECE.icon.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeminers/pm1013.fMASTERPIECE.s.icon.png",
        "isDefault": false
      }
    ]
  },
  {
    "speciesId": 1017,
    "baseDexId": 1017,
    "speciesName": "ogerpon",
    "forms": [
      {
        "formId": "ogerpon",
        "name": "ogerpon",
        "displayName": "Ogerpon",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/1017.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/1017.png",
        "isDefault": true
      },
      {
        "formId": "ogerpon-wellspring-mask",
        "name": "ogerpon-wellspring-mask",
        "displayName": "Wellspring Mask",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10273.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10273.png",
        "isDefault": true
      },
      {
        "formId": "ogerpon-hearthflame-mask",
        "name": "ogerpon-hearthflame-mask",
        "displayName": "Hearthflame Mask",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10274.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10274.png",
        "isDefault": true
      },
      {
        "formId": "ogerpon-cornerstone-mask",
        "name": "ogerpon-cornerstone-mask",
        "displayName": "Cornerstone Mask",
        "spritePath": "https://sprites.nexusdex.ai/pokeapi/10275.png",
        "shinySpritePath": "https://sprites.nexusdex.ai/pokeapi/shiny/10275.png",
        "isDefault": true
      }
    ]
  }
] as const;

export const FORM_GROUPS_BY_SPECIES_ID: ReadonlyMap<number, FormGroup> = new Map(
  POKEMON_FORM_GROUPS.map((g) => [g.speciesId, g]),
);

export const FORM_GROUPS_BY_FORM_ID: ReadonlyMap<string, FormGroup> = new Map(
  POKEMON_FORM_GROUPS.flatMap((g) => g.forms.map((f) => [f.formId, g] as const)),
);
